/* exported PLAYER_INIT, is_saving_storage_process, tv_channels_sorted_lang, tv_channels_category_list, res_url, T_SEC, T_MIN, T_HOUR, T_DAY, Vendor */

(function () {
  window.HotezaTV = {
    history: {
      _lastPage: '',
      get lastpage() {
        return this._lastPage;
      },
      set lastpage(value) {
        this._lastPage = value;
      },
    },
    key_sequence: '',
    metrics: {
      system: false,
      modules: false,
      splash: false,
      final: false,
      was_standby: false,
    },
    reg: 'initial',
    auth: 'initial',
  };

  window.appUseZoom = false;
  window.fullscreen = undefined;
  window.tv_cur_block = undefined;
  window.tv_cur_pos = undefined;
  window.tv_sel_list = $([]);
  window.tvPrevCurElem = $();
  window.tv_cur_elem = $();
  window.tv_max_pos = 0;
  window.tv_room = 0;
  window.tv_keys = {};
  /**
   * Peninsula custom keys. These keys are merged into tv_keys after vendor module initialization.
   * @see CustomKeyType in src/app/types/key-type.ts
   */
  window.tv_custom_keys = {
    CUSTOM_TV: 201801,
    CUSTOM_CHROMECAST: 201802,
    CUSTOM_AIRPLAY: 201803,
    CUSTOM_BLUETOOTH: 201804,
    CUSTOM_INPUT: 201805,
    CUSTOM_AIRTIME: 201806,
    POWER_ON: 201807,
    POWER_OFF: 201808
  };
  window.tv_last_key = undefined;
  // Используется в tv_lg.js для предотвращения tv+_channel_stop ????
  window.PLAYER_INIT = false;
  window.is_saving_storage_process = false;

  window.clip = undefined;
  window.gallery = undefined;
  window.previous_tv_keydown_overrides = [];
  // Вместо прямого присваивания используйте setCurrentTvKeydownOverride и removeCurrentTvKeydownOverride
  window.tv_keydown_override = undefined;

  window.tv_channels_sorted_lang = undefined;
  window.tv_channels_category_list = undefined;
  window._tv_channels = undefined; // отфильтрованные по группам каналы
  window._tv_hls_ctx = undefined; // nice naming

  window.weather_updater = undefined;
  window.res_url = 'res_url_not_set';
  window.api_url = 'api_url_not_set';

  window.tv_sign = 'unknown';
  window.tv_api_url = 'tv_api_url_not_set';

  window._third_party_app = null;

  // Used only in LG on 13.03.2025
  // isFocused == false, when we are turning on the Apps
  // isFocused == true, when we are in Hoteza or HDMI also
  window.isFocused = true;

  /**
   * null - Hoteza
   * string - id of some third party app
   * implemented in LG on 13.03.2025
   * @var {string | null} currentAppId
   * */
  window.currentAppId = null;

  window.tv_channels_languages_default = [
    {m0: {transcription: 'Crnogorski', image: 'i/flags/Montenegro.png'}},
    {sl: {transcription: 'Slovenski', image: 'i/flags/Slovenia.png'}}, // ISO 639-1
    {si: {transcription: 'Slovenski', image: 'i/flags/Slovenia.png'}}, // CMS
    {sk: {transcription: 'Slovenský', image: 'i/flags/Slovakia.png'}},
    {sr: {transcription: 'Српски', image: 'i/flags/Serbia.png'}},
    {hr: {transcription: 'Hrvatski', image: 'i/flags/Croatia.png'}},
    {en: {transcription: 'English', image: 'i/flags/United-Kingdom.png'}},
    {ru: {transcription: 'Русский', image: 'i/flags/Russia.png'}},
    {zh: {transcription: '普通话', image: 'i/flags/China.png'}},
    {'zh-TW': {transcription: '粵語', image: 'i/flags/_China-traditional.png'}},
    {ar: {transcription: 'العربية', image: 'i/flags/_Arabic.png'}},
    {de: {transcription: 'Deutsch', image: 'i/flags/Germany.png'}},
    {es: {transcription: 'Español', image: 'i/flags/Spain.png'}},
    {fr: {transcription: 'Français', image: 'i/flags/France.png'}},
    {tr: {transcription: 'Türkçe', image: 'i/flags/Turkey.png'}},
    {it: {transcription: 'Italiano', image: 'i/flags/Italy.png'}},
    {pt: {transcription: 'Português', image: 'i/flags/Portugal.png'}},
    {ja: {transcription: '日本語', image: 'i/flags/Japan.png'}},
    {nl: {transcription: 'Nederlands', image: 'i/flags/Netherlands.png'}},
    {fa: {transcription: 'فارسی', image: 'i/flags/_Arabic.png'}},
    {ko: {transcription: '한국어', image: 'i/flags/South-Korea.png'}},
    {da: {transcription: 'Dansk', image: 'i/flags/Denmark.png'}},
    {th: {transcription: 'Thailand', image: 'i/flags/Thailand.png'}},
    {uk: {transcription: 'Українська', image: 'i/flags/Ukraine.png'}},
    {tg: {transcription: 'Тоҷикӣ', image: 'i/flags/Tajikistan.png'}},
    {ro: {transcription: 'Moldovenească', image: 'i/flags/Moldova.png'}},
    {hy: {transcription: 'Հայերեն', image: 'i/flags/Armenia.png'}},
    {uz: {transcription: 'Оʻzbek', image: 'i/flags/Uzbekistan.png'}},
    {ky: {transcription: 'Кыргы́з', image: 'i/flags/Kyrgyzstan.png'}},
    {kk: {transcription: 'Қазақша', image: 'i/flags/Kazakhstan.png'}},
    {az: {transcription: 'Azərbaycan', image: 'i/flags/Azerbaijan.png'}},
    {id: {transcription: 'Indonesia', image: 'i/flags/Indonesia.png'}},
    {vi: {transcription: 'Tiếng Việt', image: 'i/flags/Vietnam.png'}},
    {hu: {transcription: 'Magyar', image: 'i/flags/Hungary.png'}},
    {el: {transcription: 'Ελληνικά', image: 'i/flags/Greece.png'}},
    {no: {transcription: 'Norsk', image: 'i/flags/Norway.png'}},
    {pl: {transcription: 'Polski', image: 'i/flags/Poland.png'}},
  ];

  //индикатор загрузки системы, до true - загрузка в процессе, выставляется в tv_final
  window.system_started = false;
  //индикатор, что кто-то трогал систему, используется в tv_open_app.open
  window.system_idle = true;
})();

(function () {
  $(HotezaTV).one('splashshow', function () {
    var code;
    //TODO: изменить вид, поменять в использовании (VOD, mosaic)
    var tmp = isset('config.tv.channels_languages_override');
    if (tmp && tmp.length) {
      for (let i = 0; i < tmp.length; i++) {
        code = Object.keys(tmp[i]);
        //Удаление существующего (переделать на обновление?)
        for (const index in tv_channels_languages_default) {
          if (tv_channels_languages_default[index][code]) {
            tv_channels_languages_default.splice(index, 1);
          }
        }
        //Добавление
        tv_channels_languages_default.push(tmp[i]);
      }
    }

    // Кастомный порядок языков из конфига
    var tmp_conf = isset('config.tv.channels_languages_order', ['locale']);
    if (tmp_conf && tmp_conf.length) {
      var out = [];
      for (let i2 = 0; i2 < tmp_conf.length; i2++) {
        if (tmp_conf[i2] == 'locale') {
          tmp_conf[i2] = get_language();
        }
        for (let o = tv_channels_languages_default.length - 1; o >= 0; o--) {
          code = Object.keys(tv_channels_languages_default[o])[0];
          if (code == tmp_conf[i2]) {
            out.push(tv_channels_languages_default.splice(o, 1)[0]);
          }
        }
      }
      out = out.concat(tv_channels_languages_default);
      tv_channels_languages_default = out;
      log.add(
        'CHANNELS: languages list reordered: ' +
          isset('config.tv.channels_languages_order', ['locale']).join(',') +
          ',...',
      );
    } else {
      log.add('CHANNELS: default languages list');
    }
  });
})();

(function () {
  $(HotezaTV).one('splashshow', function () {
    checkTrialModeStatus();
  });

  function removeTrialModeBanner() {
    var existing = document.getElementById('trial-mode-watermark');
    if (existing) {
      existing.parentNode.removeChild(existing);
    }
  }

  function checkTrialModeStatus() {
    var hotelId = isset('config.hotelUid', null);
    if (!hotelId) {
      log.add('Trial mode: hotelUid is not configured');
      return;
    }

    $.ajax({
      url: isset('config.admin_url', null) + 'jsonapi/isTrialMode',
      type: 'GET',
      dataType: 'json',
      data: {hotelId: hotelId},
      success: function (response) {
        if (response && response.trialMode === true) {
          createTrialModeBanner();
        }
      },
      error: function (xhr, status, error) {
        console.warn('Trial mode check failed:', status, error);
      },
    });
  }

  function createTrialModeBanner() {
    var img = document.createElement('img');
    img.id = 'trial-mode-watermark';
    img.src = 'i/installation_in_progress.svg';
    document.body.appendChild(img);
  }

  function removeTrialModeBanner() {
    var existing = document.getElementById('trial-mode-watermark');
    if (existing) {
      existing.parentNode.removeChild(existing);
    }
  }

  window.createTrialModeBanner = createTrialModeBanner;
  window.removeTrialModeBanner = removeTrialModeBanner;
})();

(function () {
  window.tv_open_app = {
    opened: false,
    open: function (must) {
      if (typeof must === 'undefined' && tv_open_app.opened) {
        return;
      }

      //TODO: удалить после реализации выхода из любого места приложения
      //при старте системы равен true, после нажатия любой кнопки - false
      if (system_idle) {
      } else {
        log.persistent.add('open not idle app', 'RELOAD');
        log.add('TV: reload, open app when not idle');
        reload_app();
        return false;
      }

      tv_open_app.opened = true;

      var suppress_welcome = isset('config.tv.suppress_initial_navigation');

      if (
        !suppress_welcome &&
        isset('config.tv.welcome_screen.enabled') &&
        (isset('config.tv.welcome_screen.always') ||
          (!isset('config.tv.welcome_screen.always') && !load_data().welcome_screen_shown))
      ) {
        tv_welcome();
        checkStartupReason();
      } else {
        setTimeout(function () {
          delete_splash().done(function () {
            if (!suppress_welcome) {
              navigate('#menu');
            }

            if (metro_menu) {
              Menu.setFirstActiveCursorInMenu();
            }

            checkStartupReason();
          });
        }, 3000);
      }
    },
  };
})();

(function () {
  $(HotezaTV).on('splashshow', function () {
    //TODO: add screen caption
    //TODO: check current state WORKS?
    get_power_state()
      .done(function (state) {
        if (state == true) {
          tv_virtual_standby_state = false;
          console.log('TV is ON');
          hash.set('standby', null);
          tv_ready();
        } else {
          tv_virtual_standby_state = true;
          //TODO: do something with time. not sync at this stage, no tz
          log.persistent.add('standby', 'SYSTEM');
          console.log('TV is STANDBY');
          hash.set('standby');
          log.add('TV: TV in Standby Mode!!!');
          setStandbyTvKeydownHandler();
        }
      })
      .fail(function (error) {
        console.log('TV in UNKNOWN STATE');
        tv_virtual_standby_state = false;
        hash.set('standby', null);
        tv_ready();
      });

    //сброс таймера проверки загрузки системы (из старта)
    clearTimeout(system_start_timer);

    //Установка таймера перезагрузки системы (в standby)
    setTimeout(function () {
      if (tv_virtual_standby_state == true) {
        if (isset('config.tv.reboot_in_standby')) {
          log.persistent.add('long standby (hack)', 'REBOOT');
          console.log('Hoteza reboot due to long STANDBY');
          tv_reboot();
        } else {
          log.persistent.add('long standby', 'RELOAD');
          console.log('Hoteza restart due to long STANDBY');
          reload_app();
        }
      } else {
        //Turned on
        log.add('TV: ON for a long time (6 hours)');
      }
    }, 6 * T_HOUR);

    //Установка таймера выключения системы (если никто не трогал)
    setTimeout(function () {
      if (system_idle == true) {
        log.persistent.add('12h idle on', 'POWEROFF');
        console.log('Hoteza turn off due to no touch');
        tv_poweroff();
      } else {
        //TODO: turn off after confirmation
        //was touched
        log.add('TV: ON for a long time (12 hours) but touched');
      }
    }, 12 * T_HOUR);
  });
})();

(function () {
  window.ua = navigator.userAgent.toLowerCase();
})();

(function () {
  $(HotezaTV).one('final', function () {
    tv_final();
  });

  function tv_final() {
    _setHandlerKeydown();

    //TODO: move earlier
    if (isset('config.tv.volume_control') == 'hoteza') {
      if (isset('_add_volume_control')) {
        _add_volume_control();
        _tv_get_volume()
          .done(function (data) {
            Volume.set(data, true);
          })
          .fail(function () {
            log.add('Volume: failed to get');
          });
      } else {
        log.add('Volume: hoteza volume control unsupported');
      }
    } else {
      if (isset('_remove_volume_control')) {
        _remove_volume_control();
      }
    }

    $('#tv_fullscreen_overlay').css('visibility', '');

    if (isset('config.tv.auto_poweroff.enabled')) {
      AutoPoweroff.init();
    }

    parentalLockAutoEnable();

    system_started = true;

    //System ServiceCodes
    ServiceCodes.registerListener(['MENUMENUMENUUPDOWNUPDOWN', 'BACKBACKBACKUPDOWNUPDOWN'], function () {
      _tv_bg_restore();
      log.persistent.add('UPDOWN service code', 'RELOAD');
      log.add('TV: reloading, code UPDOWN');
      reload_app();
    });
    //----

    window.fixChannels();
  }

  /*
  $(HotezaTV).one('final', function(){
    var tmp = storage.getItem('room');
    if(tmp.length == 3){
      storage.setItem('room', '0'+tmp);
      $.get('https://api.hoteza.com/jsonapi/marriottchange-'+tmp)
      .always(function(){
        document.location.reload();
      });
    }
  });
  */
})();

(function () {
  function tv_register() {
    var d = $.Deferred();
    var daemonUrl = isset('config.tv_daemon_url');
    //TODO: check with device tv_mac
    //get MAC
    $.post(
      daemonUrl + 'getmymac',
      function (data) {
        tv_ip = data.ip;
        tv_mac = data.mac;
        tv_sign = data.sign;

        if (!tv_mac || !tv_sign || !tv_room) {
          //МАК и ключ не получен или не установлен номер комнаты
          d.reject('nomac or noroom');
        } else {
          log.add('TV: DAEMON: IP = ' + tv_ip + ' / MAC = ' + tv_mac);

          data = {
            hotelId: get_hotelId(),
            roomNumber: tv_room,
            ip: tv_ip,
            mac: tv_mac,
            manufacturer: tv_manufacturer,
            model: tv_get_info().model,
            firmware: tv_get_info().firmware,
            sign: tv_sign,
          };

          if (typeof Events !== 'undefined' && Events.TVID()) {
            data.tvIndex = Events.TVID();
          }

          $.post(
            tv_api_url + 'registration',
            data,
            function (r) {
              if (typeof r == 'object') {
                switch (r.result) {
                  case 0:
                    if (r.data.groups) {
                      guestData.groups = r.data.groups;
                    }
                    d.resolve();
                    break;
                  case 1:
                    d.reject('invalid sign');
                    break;
                  case 2:
                    d.reject('hotel not found');
                    break;
                  case 3:
                    d.reject('MAC ' + tv_mac + ' belongs to another room');
                    break;
                  case 4:
                    d.reject('cannot overwrite MAC in this room');
                    break;
                  case 5:
                    d.reject('Cannot create token');
                    break;
                  case 6:
                    d.reject('Room Number incorrect');
                    break;
                  case 8:
                    d.reject('License Limit Exceeded');
                    break;
                  case 9:
                    d.reject('Unknown error');
                    break;
                  default:
                    d.reject('Unknown answer - ' + r.result + ' Message: ' + r.message);
                    break;
                }
              } else {
                d.reject('no result');
              }
            },
            'json',
          ).fail(function (err, error, errorThrown) {
            d.reject('fail ' + err.status + '|' + err.statusText);
          });
        }
      },
      'json',
    ).fail(function () {
      d.reject('Daemon connect failed - ' + daemonUrl);
    });
    return d.promise();
  }

  function tv_register_v2() {
    var d = $.Deferred();
    log.add('TV: registration V2');

    if (!tv_mac || !tv_room) {
      //МАК не получен или не установлен номер комнаты
      d.reject('nomac or noroom');
    } else {
      log.add('TV: IP = ' + tv_ip + ' / MAC = ' + tv_mac);

      var data = {
        v: '2',
        hotelId: get_hotelId(),
        roomNumber: tv_room,
        ip: tv_ip,
        mac: tv_mac,
        manufacturer: tv_manufacturer,
        model: tv_get_info().model,
        firmware: tv_get_info().firmware,
        serialNumber: tv_get_info().serial_number,
        ua: ua,
      };

      if (typeof Events !== 'undefined' && Events.TVID()) {
        data.tvIndex = Events.TVID();
      }

      $.post(
        tv_api_url + 'registration',
        data,
        function (r) {
          if (typeof r == 'object') {
            switch (r.result) {
              case 0:
                tv_sign = r.sign;
                if (r.data && r.data.groups) {
                  guestData.groups = r.data.groups;
                }
                d.resolve();
                break;
              case 1:
                d.reject('invalid sign');
                break;
              case 2:
                d.reject('hotel not found');
                break;
              case 3:
                d.reject('MAC ' + tv_mac + ' belongs to another room');
                break;
              case 4:
                d.reject('cannot overwrite MAC in this room');
                break;
              case 5:
                d.reject('Cannot create token');
                break;
              case 6:
                d.reject('Room Number incorrect');
                break;
              case 8:
                d.reject('License Limit Exceeded');
                break;
              case 9:
                d.reject('Unknown error ' + r.message);
                break;
              default:
                d.reject('Unknown answer - ' + r.result + ' Message: ' + r.message);
                break;
            }
          } else {
            d.reject('no result');
          }
        },
        'json',
      ).fail(function (err, error, errorThrown) {
        d.reject('failed - ' + err.status + '|' + err.statusText);
      });
    }

    return d.promise();
  }

  function tv_ready() {
    $(HotezaTV).trigger('tv_ready');

    tv_set_start_volume();

    if (isset('config.weather.enabled')) {
      if (isset('config.weather.svg_icons')) {
        var style = document.createElement('style');
        style.textContent = "@font-face { font-family: 'weather'; src: url('s/font/weather/fonts/weather-svg.ttf') format('truetype'), url('s/font/weather/fonts/weather-svg.svg#weather') format('svg'); font-weight: normal; font-style: normal; }";
        document.head.appendChild(style);
      }
      tv_weather();
      weather_updater = setInterval(tv_weather, 30 * T_MIN);
    }
    parental_lock_fill();

    tv_set_room();

    var tv_reg;
    if (isset('config.tv.hacks.tv_registration_v2')) {
      tv_reg = tv_register_v2();
    } else {
      tv_reg = tv_register();
    }
    tv_reg
      .done(function () {
        log.add('TV: registered');
        HotezaTV.reg = 'OK';
        filter_content_by_group();
        tv_auth();
      })
      .fail(function (err) {
        log.add('TV: ERROR - ' + err);
        HotezaTV.reg = err;
        guestData_clear();
        filter_content_by_group();
      });

    //Обработка галерей ПЕРЕДЕЛАТЬ!
    // $('.gallery_container IMG').on(event_link, function(){
    // Навешиваем на все картинки в галерее, кроме тех, которые должны находиться в вертикальной галерее
    var excludeScrollViewerIds = isset('config.gallery.scrollViewerIds', []);
    var simpleGalleries;
    if (excludeScrollViewerIds.length > 0) {
      simpleGalleries = $('.gallery_page')
        .not('#' + excludeScrollViewerIds.join(', #')) // Навешиваем на все картинки в галерее, кроме тех, которые
        // должны
        // находиться в вертикальной галерее
        .find('.gallery_container IMG');
    } else {
      simpleGalleries = $('.gallery_container IMG');
    }
    simpleGalleries.on(event_link, function () {
      gallery = new Gallery(this.closest('.gallery_container'));
      gallery.show(this);
    });

    clip = clipper();

    setTimeout(tv_open_app.open, 2000);
  }

  function tv_set_room() {
    if (tv_room) {
      $('#tv_fullscreen_roomnumber').html(' ' + tv_room);
      $('#tv_fullscreen_room').show();
    }
  }

  window.tv_ready = tv_ready;
})();

(function () {
  var unitsOfMeasurementsTracking = false;

  function tv_weather() {
    var data = {
      hotelId: get_hotelId(),
    };
    $.post(
      api_url + 'weather',
      data,
      function (response) {
        switch (response.result) {
          case 0:
            weather = response;
            if (weather.timestamp | 0) {
              var tmp = time.now(true) - weather.timestamp * 1000;
              if (tmp > 3 * T_HOUR) {
                //TODO: weather hide
                log.add('WEATHER: outdated: ' + toHHMMSS(tmp / 1000));
                log.post_log('WEATHER: ERROR: hotel ' + get_hotelId() + ': weather outdated: ' + toHHMMSS(tmp / 1000));
              } else {
                tv_set_weather();
                log.add('WEATHER: OK');
              }
            }
            break;
          case 1:
            log.add('WEATHER: Invalid hotel');
            clearInterval(weather_updater);
            break;
          case 2:
            log.add('WEATHER: not activated');
            clearInterval(weather_updater);
            break;
          default:
            log.add('WEATHER: response unknown');
            clearInterval(weather_updater);
            break;
        }
      },
      'json',
    ).fail(function (err) {
      log.add('WEATHER: error ' + err.status + '|' + err.statusText);
    });
  }

  function tv_set_weather() {
    var tmp_temp,
      tmp_icon = '';
    if (!weather) {
      return {};
    }

    trackUnitsOfMeasurements();

    tmp_temp = get_temp() + '&deg;' + get_symbol_temp();

    if (isset('config.weather.icon')) {
      tmp_icon = '<span class="weather-icon-' + weather.weatherIconTxt.split(' ').join('-') + '"></span>';
    }

    $('#tv_fullscreen_weather')
      .html(tmp_icon + tmp_temp)
      .show();

    return {
      icon: tmp_icon,
      temp: tmp_temp,
      desc: getlang('icon-' + weather.weatherIconTxt.split(' ').join('-')),
    };

    function trackUnitsOfMeasurements() {
      if (unitsOfMeasurementsTracking) {
        return;
      }
      unitsOfMeasurementsTracking = true;
      $(window.HotezaTV).on('valueTemperature', function () {
        if (weather) {
          tv_set_weather();
        }
      });
    }

    function get_temp() {
      if (typeof weather.tempC === 'undefined') {
        return 0;
      }

      var symbolTemp = get_symbol_temp();
      var tempC = weather.tempC;
      var temp = symbolTemp === 'F' ? Math.round(tempC * 1.8 + 32) : tempC;

      // "+" sign rule: Celsius-only, only when tempC > 0, and only if `plus` is not
      // explicitly disabled. Fahrenheit never gets a "+" prefix because 0°F is not the
      // freezing point and the sign would be semantically misleading. The canonical
      // source for the flag is guestData.weather.plus (built from config.widgets.weather
      // with a default of true) — same path used by the menu tile and weather page.
      var plusEnabled = isset('guestData.weather.plus') !== false;
      if (symbolTemp !== 'F' && tempC > 0 && plusEnabled) {
        temp = '+' + temp;
      }

      return temp;
    }

    function get_symbol_temp() {
      var guestTemp = isset('guestData.weather.valueTemperature');
      var configTemp = isset('config.weather.valueTemperature');
      var symbolTemp = guestTemp || configTemp;
      return symbolTemp === 'F' ? 'F' : 'C';
    }
  }

  window.weather = undefined;
  window.tv_weather = tv_weather;
  window.tv_set_weather = tv_set_weather;
})();

(function () {
  window.tv_channel_number = '';
  window.tv_channel_number_entered = undefined;

  function tv_channel_number_press(num) {
    if (fullscreen) {
      var channels = getChannels();

      if (tv_channel_number.length < 4) {
        tv_channel_number += '' + num;
      }
      if (!$('#tv_channel_number').length) {
        $(document.body).append($('<div id="tv_channel_number"></div>'));
      }
      $('#tv_channel_number').html(tv_channel_number + '-');
      if (tv_channel_number_entered) {
        clearTimeout(tv_channel_number_entered);
      }
      tv_channel_number_entered = setTimeout(function () {
        tv_channel_number = tv_channel_number | 0;
        if (channels[tv_channel_number - 1]) {
          $('#tv_channel_number').html(tv_channel_number);

          if (isset('config.tv_channellist_type') === 'vertical_new') {
            VerticalChannel.chooseChannel(tv_channel_number - 1);
          } else {
            tv_channel_show(tv_channel_number - 1);
          }
          tv_channellist_show();
          tv_channellist_fade();
        } else {
          $('#tv_channel_number').html('<span style="color:Red;">' + tv_channel_number + '</span>');
        }

        tv_channel_number = '';
        setTimeout(function () {
          $('#tv_channel_number').remove();
        }, 3000);
      }, 1000);
    }
  }

  window.tv_channel_number_press = tv_channel_number_press;
})();

(function () {
  /**
   * Custom keydown handler used when the TV is displaying an external source (e.g., HDMI).
   * This function is intended to be assigned to `tv_keydown_override` on philips, samsung, tizen and tizen_tep.
   * 
   * Why it's needed:
   * When the user switches to an external HDMI input, the Hoteza UI is usually hidden, 
   * but the app still runs in the background. The standard UI keydown handlers would try to navigate hidden menus.
   * 
   * What it does:
   * It intercepts remote control key presses during external source playback.
   * 
   * @param {Event|undefined} e - The keydown event object
   */
  function _tv_keydown_external(e) {
    if (!e) {
      e = event;
    }
    var code = e.keyCode ? e.keyCode : e.which;
    switch (code) {
      case tv_keys.INPUT:
      case tv_keys.EXIT:
      case tv_keys.BACK:
        _tv_source(['TV', 0]);
        break;

      case tv_keys.MENU:
      case tv_keys.HOME:
        _tv_source(['TV', 0]);
        navigate('#menu');
        break;

      case tv_keys.POWER_OFF:
        tv_poweroff();
        break;

      default:
        break;
    }
  }

  window._tv_keydown_external = _tv_keydown_external;
})();

(function () {
  var keys = [tv_keys.PORTAL, tv_keys.GUIDE, tv_keys.Q_MENU, tv_keys.MENU, tv_keys.HOME, tv_keys.EXIT];

  function tv_get_exit_keys(handleBack) {
    return handleBack ? keys.concat(tv_keys.BACK) : keys.slice();
  }

  window.tv_get_exit_keys = tv_get_exit_keys;
})();

(function () {
  function processServiceCode(code) {
    if (!code || code.trim() === '') {
      custom_dialog('alert', 'Error', 'Service code can not be empty', 'showServiceCodeDialog();');
      return;
    }
    if (!/^\d{4}$/.test(code)) {
      custom_dialog('alert', 'Error', 'Wrong service code. Enter valid code please.', 'showServiceCodeDialog();');
      return;
    }
    if (!ServiceCodes.checkCodes(code)) {
      custom_dialog('alert', 'Error', 'Unknown service code', 'showServiceCodeDialog();');
      return;
    }
    ServiceCodes.evaluate(code);
  }

  function showServiceCodeDialog() {
    custom_input({
      title: 'Service Code',
      text: 'Enter service code',
      onConfirm: function (code) {
        processServiceCode(code);
      },
    });
  }

  window.showServiceCodeDialog = showServiceCodeDialog;
})();

(function () {
  var tv_cur_offset,
    tv_cur_offset_target = $(),
    tv_offset_threshold = 50, // is needed so that the selected element always has an offset from the edge of .content
    tv_cur_offset_target_top,
    tv_max_offset,
    container,
    shift;

  function tv_keydown(event, isNotOverride) {
    if (system_started) {
      system_idle = false;
    }

    var code = getKeyCode(event);

    //Object.keys(tv_keys)[Object.values(tv_keys).indexOf(code)]
    tv_last_key = code;

    // system-wide button interception mechanism via config
    // config.tv.additionalKeycodes.[vendor].additionalKeycodes
    if (handleAdditionalKeycodes(code)) {
      return true;
    }

    //Механизм перехвата нажатия кнопок сторонними модулями
    if (
      typeof tv_keydown_override === 'function' &&
      !isNotOverride &&
      //костыльная отмена оверрайда кнопок громкости (если перехватываются)
      [tv_keys.VOL_UP, tv_keys.VOL_DOWN, tv_keys.MUTE].indexOf(code) == -1
    ) {
      try {
        tv_keydown_override(event);
      } catch (e) {
        log.add('Error executing override function (' + e + ')');
        console.error(e);
        log.post_error('Error executing override function (' + e + ')');
      }
      return false;
    }

    if (!tv_cur_block) {
      navigate('#menu');
      if ([tv_keys.RED, tv_keys.BLUE, tv_keys.EXIT].indexOf(code) === -1) {
        return true;
      }
    }

    if (tv_cur_elem && tv_cur_elem.length && tv_cur_elem.get(0).hasAttribute('ontvkey')) {
      var key = tv_keys_reverse[code];

      var tv_cur_trigger_elem = $();
      if (tv_cur_elem.get(0).hasAttribute('on_' + key)) {
        tv_cur_trigger_elem = tv_cur_elem;
      } else if (tv_cur_elem.find('[on_' + key + ']').length) {
        tv_cur_trigger_elem = tv_cur_elem.find('[on_' + key + ']');
      }

      if (tv_cur_trigger_elem.length) {
        tv_cur_trigger_elem.trigger(event_link);
      }
    }

    if (!fullscreen && tv_cur_block != 'dialog') {
      var _num_codes = [
        tv_keys.NUM_0,
        tv_keys.NUM_1,
        tv_keys.NUM_2,
        tv_keys.NUM_3,
        tv_keys.NUM_4,
        tv_keys.NUM_5,
        tv_keys.NUM_6,
        tv_keys.NUM_7,
        tv_keys.NUM_8,
        tv_keys.NUM_9,
      ];
      var tmp = _num_codes.indexOf(code);
      if (tmp == -1) {
        HotezaTV.key_sequence += tv_keys_reverse[code] || 'UNK';
      } else {
        HotezaTV.key_sequence += tmp;
      }
      HotezaTV.key_sequence = HotezaTV.key_sequence.substr(0, 50);
      if (tv_channel_number_entered) {
        clearTimeout(tv_channel_number_entered);
      }
      tv_channel_number_entered = setTimeout(function () {
        switch (HotezaTV.key_sequence) {
          case 'LEFTLEFTUPUPRIGHTRIGHTDOWNDOWN':
          case 'BACKBACKLEFTLEFTRIGHTRIGHTDOWNDOWN':
            showServiceCodeDialog();
            break;
          case 'BACKBACKBACKLEFTRIGHTRIGHTUPRIGHT':
          case 'MENUMENUMENULEFTRIGHTRIGHTUPRIGHT':
            //Diagnostics IDQDD
            console.log('Diagnotics sequence');
            if (typeof Tests == 'undefined') {
              Loader.start();
              Modules.load('Tests').done(function () {
                Loader.stop();
              });
            } else {
              Tests.open();
            }
            break;
          default:
            ServiceCodes.evaluate(HotezaTV.key_sequence);
            break;
        }
        HotezaTV.key_sequence = '';
      }, 1000);
    }

    switch (code) {
      case 0:
        break;
      case tv_keys.NUM_0:
        tv_channel_number_press(0);
        break;
      case tv_keys.NUM_1:
        tv_channel_number_press(1);
        break;
      case tv_keys.NUM_2:
        tv_channel_number_press(2);
        break;
      case tv_keys.NUM_3:
        tv_channel_number_press(3);
        break;
      case tv_keys.NUM_4:
        tv_channel_number_press(4);
        break;
      case tv_keys.NUM_5:
        tv_channel_number_press(5);
        break;
      case tv_keys.NUM_6:
        tv_channel_number_press(6);
        break;
      case tv_keys.NUM_7:
        tv_channel_number_press(7);
        break;
      case tv_keys.NUM_8:
        tv_channel_number_press(8);
        break;
      case tv_keys.NUM_9:
        tv_channel_number_press(9);
        break;

      // попытка отследить почему выключаются STB в MGM
      case tv_keys.DISC_POWER_OFF:
        log.add('LG: DISC_POWER_OFF key');
        break;

      case tv_keys.POWER:
        log.add('LG: POWER key');
        break;
      // попытка отследить почему выключаются STB в MGM

      case tv_keys.POWER_ON:
        tv_poweron();
        break;

      case tv_keys.POWER_OFF:
        tv_poweroff();
        break;

      case tv_keys.INPUT:
        navigate('#sources_page');
        break;

      case tv_keys.UP:
        tv_up();
        break;
      case tv_keys.DOWN:
        tv_down();
        break;
      case tv_keys.LEFT:
        tv_left();
        break;
      case tv_keys.RIGHT:
        tv_right();
        break;
      case tv_keys.ENTER:
        tv_ok();
        if (event.stopPropagation) {
          event.stopPropagation();
        }
        break;
      case tv_keys.EXIT:
      case tv_keys.BACK:
        // Samsung exit and return fix
        if (isset('widgetAPI.blockNavigation')) {
          widgetAPI.blockNavigation(event);
        }
        tv_back();
        break;
      case tv_keys.CH_UP:
        tv_chup();
        break;
      case tv_keys.CH_DOWN:
        tv_chdown();
        break;

      case tv_keys.RED:
        if (tv_cur_block === 'popup') {
          tv_back();
        }

        if (tv_cur_block !== 'VODplayer') {
          tv_mode();
        }
        break;
      case tv_keys.GREEN:
        if (fullscreen && isset('config.tv_channellist_type') === 'vertical_new') {
          VerticalChannel.toggleBlock('category');
        } else if (fullscreen && !tv_channellist_hidden) {
          tv_channel_category_build();
        }

        if (tv_cur_block === 'VODplayer' && isset('config.tv.sleep_timer.enabled')) {
          sleep_timer.open(undefined, 'closeSleepTimerForVOD();');
        }

        // открываем popup фильтров магазина
        if (tv_cur_block === 'pagelist') {
          Services.openChooseFilters();
        }

        //TODO: заменить костыль на управление кнопками
        if (active_page == '#sanatorium_schedule') {
          Sanatorium.select_guest_popup();
        }

        break;
      case tv_keys.YELLOW:
        if (tv_cur_block === 'cart') {
          shop_item_delete();
        }

        if (tv_cur_block === 'VODplayer') {
          VOD.show_menu('subtitles');
        }
        break;
      case tv_keys.BLUE:
        if (fullscreen) {
          tv_change_audio();
        } else {
          if (tv_cur_block === 'VODplayer') {
            VOD.show_menu('languages');
          } else {
            navigate('#language_select');
          }
        }
        //tv_sel_block(active_page_id);
        break;

      // Данная кнопка в lg означает кнопку настроек
      case tv_keys.MENU:
        if (tv_lg_mark) {
          navigate('#settings');
          break;
        }
      case tv_keys.PORTAL:
      case tv_keys.GUIDE:
      case tv_keys.Q_MENU:
      case tv_keys.HOME:
        if (fullscreen) {
          tv_mode();
        } else {
          navigate('#menu');
        }
        break;

      //только на Филипсах xx14
      case tv_keys.YOUTUBE:
        Apps.open('youtube');
        break;
      case tv_keys.NETFLIX:
        Apps.open('netflix');
        break;
      case tv_keys.CAST:
        _tv_miracast();
        break;

      case tv_keys.REWIND:
        if (tv_cur_block === 'VODplayer') {
          VOD.rwd(20);
        }
        break;

      case tv_keys.STOP:
        if (tv_cur_block === 'VODplayer') {
          tv_back(); //VOD.stop();
        }
        break;

      case tv_keys.FAST_FORWARD:
        if (tv_cur_block === 'VODplayer') {
          VOD.ffw(20);
        }
        break;

      case tv_keys.PAUSE:
        if (tv_cur_block === 'VODplayer') {
          VOD.pause();
        }
        break;

      case tv_keys.PLAY:
        if (tv_cur_block === 'VODplayer') {
          VOD.play();
        }
        break;

      case tv_keys.PLAYPAUSE:
        if (tv_cur_block === 'VODplayer') {
          if (VOD.playerDOM.paused) {
            VOD.play();
          } else {
            VOD.pause();
          }
        }
        break;

      case tv_keys.DOOREYE:
        if (typeof DoorEye != 'undefined') {
          DoorEye.ask();
        } else {
          log.add('DoorEye: module not loaded!');
        }
        break;

      case tv_keys.VOL_UP:
        //TODO: max volume from config
        if (typeof _tv_set_volume == 'function') {
          _tv_get_volume()
            .done(function (data) {
              var tmp = Math.min(99, data + 1);
              _tv_set_volume(tmp);
              //TODO: должно быть через event handler
              Volume.set(tmp);
            })
            .fail(function (f) {
              log.add('VOLUME: failed to get');
            });
        } else {
          log.add('VOLUME: not implemented');
        }
        break;

      case tv_keys.VOL_DOWN:
        if (typeof _tv_set_volume == 'function') {
          _tv_get_volume()
            .done(function (data) {
              var tmp = Math.max(0, data - 1);
              _tv_set_volume(tmp);
              //TODO: должно быть через event handler
              Volume.set(tmp);
            })
            .fail(function (f) {
              log.add('VOLUME: failed to get');
            });
        } else {
          log.add('VOLUME: not implemented');
        }
        break;

      case tv_keys.MUTE:
        tv_mute()
          .done(function (data) {
            if (data) {
              Volume.set(-1);
            } else {
              _tv_get_volume().done(function (volume) {
                Volume.set(volume);
              });
            }
          })
          .fail(function () {
            console.log('VOLUME: mute failed');
          });
        break;

      case tv_keys.NUMBERS:
        Keypad.toggle();
        break;

      default:
        //tv_log('code ' + code);
        break;
    }
  }
  /**
   * Scrolls the page in the specified direction
   * @param {string} direction - direction ('up' or 'down')
   */
  function scrollPage(direction) {
    var content = tv_cur_offset_target.length
      ? tv_cur_offset_target
      : $(active_page).find('.content');

    if (!content.length) {
      return;
    }

    var isUp = direction === 'up';
    var offset = 50;
    var tmp_parent = content.parent();
    var shift;

    if ($(active_page).attr('scroll_to_bottom')) {
      if (isUp) {
        shift = Math.max(
          tmp_parent.height() - content.outerHeight(),
          Math.min(content.position().top + offset, 0)
        );
      } else {
        shift = Math.max(
          content.position().top - offset,
          tmp_parent.height() - content.outerHeight()
        );
      }
      content[0].style.top = shift + 'px';
    } else {
      if (isUp) {
        shift = Math.min(
          0,
          Math.max(
            content.position().top + offset,
            tmp_parent.height() - content.outerHeight()
          )
        );
      } else {
        shift = Math.min(
          0,
          Math.max(
            content.position().top - offset,
            tmp_parent.height() - content.outerHeight()
          )
        );
      }
      content[0].style.top = shift + 'px';
    }

    metro_menu_calc(null, true);
    move_scroll(shift);
  }

  function tv_up() {
    var tmp = $(active_page).find('.content'),
      tmp_parent = tmp.parent(),
      shift;

    if (tv_cur_elem.attr('selectable') !== undefined) {
      // Don't scroll the page and move cursor if element has onUp handler
      // If you need both scrolling and onUp handler, use scrollPage function on onUp event
      if (!tv_cur_elem.attr('onUp')) {
        scrollPage('up');
      }

      return execDirectionAction('up', tv_cur_elem);
    } else if (tv_cur_block === 'menu') {
      if (metro_menu) {
        metro_menu_move('up');
        return true;
      }

      if (custom_menu) {
        return handleSelectableNavigation('up');
      }

      if (tv_cur_pos > 0) {
        tv_cur_pos--;
      } else {
        tv_cur_pos = 0;
      }
    } else if (tv_cur_block === 'service_page') {
      tmp = $(active_page).find('.content');
      tmp_parent = tmp.parent();

      if ($(active_page).attr('scroll_to_bottom')) {
        shift = Math.max(tmp_parent.height() - tmp.outerHeight(), Math.min(tmp.position().top + 50, 0));
        tmp[0].style.top = shift + 'px';
      } else {
        shift = Math.min(0, Math.max(tmp.position().top + 50, tmp_parent.height() - tmp.outerHeight()));
        tmp[0].style.top = shift + 'px';
      }

      if (tv_sel_list[tv_cur_pos - 1] && $(tv_sel_list[tv_cur_pos - 1]).hasClass('button')) {
        tv_cur_pos--;
        tv_sel_cur('up');
      }

      move_scroll(shift);
      return true;
    } else if (tv_cur_block === 'show_gallery') {
      return true;
    } else if (
      tv_cur_block === 'shopitem' ||
      ((tv_cur_block === 'order_details' || tv_cur_block === 'orders') && tv_sel_list.length === 1)
    ) {
      tmp = $(active_page).find('.content');
      tmp_parent = tmp.parent();

      if ($(active_page).attr('scroll_to_bottom')) {
        shift = Math.max(tmp_parent.height() - tmp.outerHeight(), Math.min(tmp.position().top + 50, 0));
        tmp[0].style.top = shift + 'px';
      } else {
        shift = Math.min(0, Math.max(tmp.position().top + 50, tmp_parent.height() - tmp.outerHeight()));
        tmp[0].style.top = shift + 'px';
      }

      move_scroll(shift);

      return metro_menu_move('up');
    } else if (
      tv_cur_block === 'settings' ||
      tv_cur_block === 'weather_select_location' ||
      tv_cur_block === 'mod_playlist' ||
      tv_cur_block === 'popup' ||
      tv_cur_block === 'toppings' ||
      tv_cur_block === 'language' ||
      tv_cur_block === 'category' ||
      tv_cur_block === 'cart' ||
      ((tv_cur_block === 'order_details' || tv_cur_block === 'orders') && tv_sel_list.length > 1)
    ) {
      if (tv_cur_pos > 0) {
        tv_cur_pos--;
      } else {
        tv_cur_pos = 0;
      }
    } else if (tv_cur_block === 'dialog') {
      metro_menu_move('up');
      return true;
    } else if (tv_cur_block === 'pagelist' || tv_cur_block === 'VODcategory') {
      metro_menu_move('up');

      if (tv_cur_block === 'VODcategory') {
        VirtualScroll.set(tv_cur_block, tv_cur_block);
      }
      return true;
    } else if (tv_cur_block === 'feedback') {
      if (isStarOrEmoticon(tv_cur_elem)) {
        tmp = tv_cur_elem.index();
        if (tv_cur_pos - (tmp + 1) > 0) {
          tv_cur_pos = tv_cur_pos - (tmp + 1);
        }
      } else {
        if (tv_cur_pos > 0) {
          tv_cur_pos--;
        } else {
          tv_cur_pos = 0;
        }
      }
    } else if (tv_cur_block === 'tv_channellist') {
      if (isset('config.tv_channellist_type') === 'vertical_new') {
        VerticalChannel.showEpg();
      }

      tv_left();
      return true;
    } else if (tv_cur_block === 'VODplayer') {
      if (!VOD.playerVisible) {
        VOD.show();
      }
    } else if (tv_cur_block !== 'tv_welcome') {
      // DEFAULT
      tmp = $(active_page).find('.content');
      tmp_parent = tmp.parent();

      if ($(active_page).attr('scroll_to_bottom')) {
        shift = Math.max(tmp_parent.height() - tmp.outerHeight(), Math.min(tmp.position().top + 50, 0));
        tmp[0].style.top = shift + 'px';
      } else {
        shift = Math.min(0, Math.max(tmp.position().top + 50, tmp_parent.height() - tmp.outerHeight()));
        tmp[0].style.top = shift + 'px';
      }

      move_scroll(shift);
    }

    change_sel_list('up');
    tv_sel_cur();
  }

  function tv_down() {
    var tmp, tmp_parent, shift;

    if (!tv_cur_block) {
      navigate('#menu');
    } else {
      if (tv_cur_elem.attr('selectable') !== undefined) {
        // Don't scroll the page and move cursor if element has onDown handler
        // If you need both scrolling and onUp handler, use scrollPage function on onDown event
        if (!tv_cur_elem.attr('onDown')) {
          scrollPage('down');
        }

        return execDirectionAction('down', tv_cur_elem);
      }
      else if (tv_cur_block === 'menu') {
        if (metro_menu) {
          metro_menu_move('down');
          return true;
        }

        if (scandic_menu) {
          return false;
        }

        if (custom_menu) {
          return handleSelectableNavigation('down');
        }

        if (tv_cur_pos < tv_max_pos - 1) {
          tv_cur_pos++;
        } else {
          tv_cur_pos = tv_max_pos - 1;
        }
      }
      else if (tv_cur_block === 'service_page') {
        tmp = $(active_page).find('.content');
        tmp_parent = tmp.parent();

        if ($(active_page).attr('scroll_to_bottom')) {
          shift = Math.max(tmp.position().top - 50, tmp_parent.height() - tmp.outerHeight());
          tmp[0].style.top = shift + 'px';
        } else {
          shift = Math.min(0, Math.max(tmp.position().top - 50, tmp_parent.height() - tmp.outerHeight()));
          tmp[0].style.top = shift + 'px';
        }

        move_scroll(shift);

        if (tv_cur_elem.hasClass('button') && tv_sel_list[tv_cur_pos + 1]) {
          tv_cur_pos++;
          tv_sel_cur('down');
        }

        return true;
      }
      else if (tv_cur_block === 'show_gallery') {
        return true;
      }
      else if (
        tv_cur_block === 'shopitem' ||
        ((tv_cur_block === 'order_details' || tv_cur_block === 'orders') && tv_sel_list.length === 1)
      ) {
        tmp = $(active_page).find('.content');
        tmp_parent = tmp.parent();

        if ($(active_page).attr('scroll_to_bottom')) {
          shift = Math.max(tmp.position().top - 50, tmp_parent.height() - tmp.outerHeight());
        } else {
          shift = Math.min(0, Math.max(tmp.position().top - 50, tmp_parent.height() - tmp.outerHeight()));
        }

        tmp[0].style.top = shift + 'px';
        move_scroll(shift);

        return metro_menu_move('down');
      }
      else if (tv_cur_block === 'dialog') {
        metro_menu_move('down');
        return true;
      }
      else if (tv_cur_block === 'pagelist' || tv_cur_block === 'VODcategory') {
        metro_menu_move('down');

        if (tv_cur_block === 'VODcategory') {
          VirtualScroll.set(tv_cur_block, tv_cur_block);
        }
        return true;
      }
      else if (tv_cur_block === 'feedback') {
        var rateableItemsAmount = 5;

        var isCurElementStar = isStarOrEmoticon(tv_cur_elem);
        var curItemNumber = isCurElementStar ? tv_cur_elem.index() + 1 : 0;
        var curElOffset = isCurElementStar ? rateableItemsAmount - curItemNumber : 0;

        var nextElIndex = tv_cur_pos + curElOffset + 1;
        var nextEl = $(tv_sel_list[nextElIndex]);

        var isNextElementStar = isStarOrEmoticon(nextEl);
        var nextElOffset = isNextElementStar ? rateableItemsAmount - 1 : 0;
        var allOffsets = curElOffset + nextElOffset;

        var tvCurNextPos = tv_cur_pos + allOffsets + 1;

        // Math.min for blocking cursor moving further, when user came to page's end
        tv_cur_pos = Math.min(tvCurNextPos, tv_max_pos - 1);
      }
      else if (tv_cur_block === 'tv_channellist') {
        if (isset('config.tv_channellist_type') === 'vertical_new') {
          VerticalChannel.showEpg();
        }

        tv_right();
        return true;
      }
      else if (tv_cur_block === 'VODplayer') {
        if (!VOD.playerVisible) {
          VOD.show();
        }
      }
      else if (
        tv_cur_block === 'settings' ||
        tv_cur_block === 'weather_select_location' ||
        tv_cur_block === 'mod_playlist' ||
        tv_cur_block === 'popup' ||
        tv_cur_block === 'toppings' ||
        tv_cur_block === 'language' ||
        tv_cur_block === 'category' ||
        tv_cur_block === 'cart' ||
        ((tv_cur_block === 'order_details' || tv_cur_block === 'orders') && tv_sel_list.length > 1)
      ) {
        if (tv_cur_pos < tv_max_pos - 1) {
          tv_cur_pos++;
        }
      }
      else if (tv_cur_block !== 'tv_welcome') {
        tmp = $(active_page).find('.content');
        tmp_parent = tmp.parent();

        if ($(active_page).attr('scroll_to_bottom')) {
          shift = Math.max(tmp.position().top - 50, tmp_parent.height() - tmp.outerHeight());
          tmp[0].style.top = shift + 'px';
        } else {
          shift = Math.min(0, Math.max(tmp.position().top - 50, tmp_parent.height() - tmp.outerHeight()));
          tmp[0].style.top = shift + 'px';
        }

        move_scroll(shift);
      }
    }

    change_sel_list('down');
    tv_sel_cur();
  }

  function move_scroll(shift, target, suffix) {
    var scrollId = (target || active_page_id) + (suffix ? '_' + suffix : '') + '_scroll_inner';
    var scrollEl = document.getElementById(scrollId);
    // TODO: I don't think 'menu' block checking should be here
    if (!scrollEl || tv_cur_block === 'menu') {
      return;
    }

    var value = Math.min(scrollEl.max, Math.max(0, -shift * scrollEl.coef)) | 0;

    scrollEl.style.top = value + 'px';
  }

  function tv_left() {
    if (tv_cur_elem.attr('selectable') !== undefined) {
      return execDirectionAction('left', tv_cur_elem);
    } else if (tv_cur_block === 'menu') {
      if (metro_menu) {
        metro_menu_move('left');
        return true;
      }

      if (scandic_menu) {
        var isPermitted = cursorMovingPermitted.get({
          key: 'scandic_menu',
          direct: 'left',
        });

        if (!isPermitted) {
          return false;
        }

        if (tv_cur_pos > 0) {
          previousPosition.set(tv_cur_pos);
          tv_cur_pos--;
          tv_sel_cur();
        }

        return true;
      }

      if (custom_menu) {
        return handleSelectableNavigation('left');
      }
    } else if (tv_cur_block === 'pagelist' || tv_cur_block === 'VODcategory') {
      metro_menu_move('left');
      
      if (tv_cur_block === 'VODcategory') {
        VirtualScroll.set(tv_cur_block, tv_cur_block);
      }
      return true;
    } else if (tv_cur_block === 'cart') {
      if (tv_cur_elem.hasClass('shop_plusminus')) {
        shop_minus_persons();
      }
    } else if (tv_cur_block === 'gallery') {
      if (tv_cur_pos > 0) {
        tv_cur_pos--;
        var tmp = $(active_page).find('.gallery_indicator');
        tmp.find('DIV.current').removeClass('current');
        $(tmp.find('DIV')[tv_cur_pos]).addClass('current');
        $(active_page).find('.gallery_container')[0].style[window.css_transform] =
          'translate3d(' + -window.pw * tv_cur_pos + 'px,0,0)';
      }
    } else if (tv_cur_block === 'guide') {
      if (tv_cur_pos > 0) {
        tv_cur_pos--;
      }
    } else if (tv_cur_block === 'tv_channellist') {
      if (tv_channellist_hidden) {
        tv_channellist_show(true);
      }
      if (tv_cur_pos > 0) {
        tv_cur_pos--;
      } else {
        if (isset('config.tv_channellist_type') === 'vertical_new') {
          tv_cur_pos = tv_max_pos - 1;
        } else {
          return true;
        }
        //tv_cur_pos = tv_max_pos - 1;
      }
      tv_channellist_fade(true);
    } else if (tv_cur_block === 'service_page') {

      return true;
    } else if (tv_cur_block === 'settings') {
      //actually DEAFULT
      if (
        tv_sel_list[tv_cur_pos - 1] &&
        ($(tv_sel_list[tv_cur_pos - 1]).hasClass('timepicker') || $(tv_sel_list[tv_cur_pos - 1]).hasClass('button'))
      ) {
        tv_cur_pos--;
      } else {
        if (tv_cur_elem.hasClass('button')) {
          return tv_back();
        }
      }
    } else if (tv_cur_block === 'shopitem') {
      if (tv_cur_elem.hasClass('shop_plusminus')) {
        shop_minus();
      } else {
        return metro_menu_move('left');
      }
    } else if (tv_cur_block === 'toppings') {
      if (tv_cur_elem.hasClass('shop_plusminus')) {
        shop_minus('#' + tv_cur_elem.attr('id'));
      } else if (tv_cur_elem.hasClass('shop_radio')) {
        shop_change_radio('#' + tv_cur_elem.attr('id'));
      }
    } else if (tv_cur_block === 'feedback') {
      if (isStarOrEmoticon(tv_cur_elem)) {
        if (tv_cur_elem.index() > 0) {
          tv_cur_pos--;
        }
      }
    } else if (tv_cur_block === 'tv_welcome') {
      if (tv_cur_elem.hasClass('btn_lng')) {
        if (tv_cur_pos > 0) {
          tv_cur_pos--;
        } else {
          return true;
        }
      }
    } else if (tv_cur_block === 'dialog' || tv_cur_block === 'popup') {
      metro_menu_move('left');
      return true;
    } else if (tv_cur_block === 'VODplayer') {
      if (VOD.playerVisible) {
        if (tv_cur_pos > 0) {
          tv_cur_pos--;
        }
        VOD.hideReset();
      } else {
        VOD.show();
      }
    } else if (tv_cur_block === 'mod_playlist' || tv_cur_block === 'time_picker') {
      if (tv_cur_pos > 0) {
        tv_cur_pos--;
      }
    } else {
      //TODO: move to module override
      if (tv_cur_block == 'scroll') {
        scroll_to_top();
      }
    }
    tv_sel_cur();
  }

  function tv_right() {
    if (tv_cur_elem.attr('selectable') !== undefined) {
      return execDirectionAction('right', tv_cur_elem);
    }
    else if (tv_cur_block === 'menu') {
      if (metro_menu) {
        metro_menu_move('right');
        return true;
      }

      if (scandic_menu) {
        var isPermitted = cursorMovingPermitted.get({
          key: 'scandic_menu',
          direct: 'right',
        });

        if (!isPermitted) {
          return false;
        }

        if (tv_cur_pos < tv_max_pos - 1) {
          previousPosition.set(tv_cur_pos);
          tv_cur_pos++;
          tv_sel_cur();
        }

        return true;
      }

      if (custom_menu) {
        return handleSelectableNavigation('right');
      }

      if (widgetObserver.hasInitializedWidget(active_page_id)) {
        widgetObserver.open(active_page_id);
        return;
      }

      //TODO: странная механика (сделано только для будильника в классике)
      var activeItem = document.querySelector('#menu .active');
      if (activeItem && activeItem.hasAttribute('onvclick')) {
        return $(activeItem).trigger(event_link);
      }

      tv_sel_block(active_page_id);
      return true;
    }
    else if (tv_cur_block === 'pagelist' || tv_cur_block === 'VODcategory') {
      metro_menu_move('right');

      if (tv_cur_block === 'VODcategory') {
        VirtualScroll.set(tv_cur_block, tv_cur_block);
      }
      return true;
    }
    else if (tv_cur_block === 'cart') {
      if (tv_cur_elem.hasClass('shop_plusminus')) {
        shop_plus_persons();
      }
    }
    else if (tv_cur_block === 'gallery') {
      if (tv_cur_pos < tv_max_pos - 1) {
        tv_cur_pos++;
        var tmp = $(active_page).find('.gallery_indicator');
        tmp.find('DIV.current').removeClass('current');
        $(tmp.find('DIV')[tv_cur_pos]).addClass('current');
        $(active_page).find('.gallery_container')[0].style[window.css_transform] =
          'translate3d(' + -window.pw * tv_cur_pos + 'px,0,0)';
      }
    }
    else if (tv_cur_block === 'guide') {
      if (tv_cur_pos < tv_max_pos - 1) {
        tv_cur_pos++;
      }
    }
    else if (tv_cur_block === 'tv_channellist') {
      if (tv_channellist_hidden) {
        tv_channellist_show(true);
      }
      if (tv_cur_pos < tv_max_pos - 1) {
        tv_cur_pos++;
      } else {
        if (isset('config.tv_channellist_type') === 'vertical_new') {
          tv_cur_pos = 0;
        } else {
          return true;
        }

        //tv_cur_pos = 0;
      }
      tv_channellist_fade(true);
    }
    else if (tv_cur_block === 'shopitem') {
      if (tv_cur_elem.hasClass('shop_plusminus')) {
        shop_plus();
      } else {
        return metro_menu_move('right');
      }
    }
    else if (tv_cur_block === 'toppings') {
      if (tv_cur_elem.hasClass('shop_plusminus')) {
        shop_plus('#' + tv_cur_elem.attr('id'));
      } else if (tv_cur_elem.hasClass('shop_radio')) {
        shop_change_radio('#' + tv_cur_elem.attr('id'));
      }
    }
    else if (tv_cur_block === 'feedback') {
      if (isStarOrEmoticon(tv_cur_elem)) {
        if (tv_cur_elem.index() < 4) {
          tv_cur_pos++;
        }
      }
    }
    else if (tv_cur_block === 'tv_welcome') {
      if (tv_cur_elem.hasClass('btn_lng')) {
        if (tv_cur_pos < tv_max_pos - 1) {
          tv_cur_pos++;
        } else {
          return true;
        }
      }
    }
    else if (tv_cur_block === 'dialog' || tv_cur_block === 'popup') {
      metro_menu_move('right');
      return true;
    }
    else if (tv_cur_block === 'VODplayer') {
      //VOD.ffw(10);
      if (VOD.playerVisible) {
        if (tv_cur_pos < tv_max_pos - 1) {
          tv_cur_pos++;
        }
        VOD.hideReset();
      } else {
        VOD.show();
      }
    }
    else if (tv_cur_block === 'service_page') {
      return true;
    }
    else if (tv_cur_block === 'settings') {
      //actually DEAFULT
      if ((tv_cur_elem.hasClass('button') || tv_cur_elem.hasClass('timepicker')) && tv_sel_list[tv_cur_pos + 1]) {
        tv_cur_pos++;
      }
    }
    else if (tv_cur_block === 'mod_playlist' || tv_cur_block === 'time_picker') {
      if (tv_sel_list[tv_cur_pos + 1]) {
        tv_cur_pos++;
      }
    }
    else {
      //TODO: move to module override
      if (tv_cur_block == 'scroll') {
        scroll_to_bottom();
      }
    }

    tv_sel_cur();
  }

  /**
   * Moves the cursor to the selected element and scrolls the page if necessary.
   *
   * The default behavior assumes that the selected element should have some offset
   * from the edge of .content (defined by tv_offset_threshold) to prevent it from
   * sticking to the container edge. This ensures better visibility of the selected element.
   * Also, if tv_cur_pos is 0, .content will be scrolled to the very top.
   *
   * WARNING: If a static element is selected that is not within .content and is located
   * at a distance less than 50px (default threshold), .content will constantly scroll.
   * In this case, you need to either increase this distance or handle this case specifically.
   *
   * @param {boolean} [btn_move] - Indicates if the movement was triggered by a button press
   */
  function tv_sel_cur(btn_move) {
    if (window.CustomNotification && window.CustomNotification.isAnimating) {
      $('#tv_cur').hide();
      return $(window).one('finish_animate', tv_sel_cur);
    }

    if (!tv_max_pos) {
      $('#tv_cur').hide();
      return false;
    }

    tvPrevCurElem = tv_cur_elem;
    tv_cur_elem = tv_sel_list.eq(tv_cur_pos);

    var tv_cur_height = tv_cur_elem.outerHeight(true);
    var tv_scroll_suffix;

    if (tv_cur_block === 'menu') {
      if (!config.menu || config.menu === 'classic') {
        tv_cur_offset_target = $('#menu');
      } else if (config.menu === 'scandic') {
        tv_cur_offset_target = $('#menu ul');
      } else if (config.menu === 'custom') {
        if (tv_cur_elem.parent().hasClass('items-wrapper')) {
          tv_cur_offset_target = tv_cur_elem.parent();
        } else {
          tv_cur_offset_target = $('#menu');
        }
      } else {
        //TODO: UL in #menu
        tv_cur_offset_target = $('#menu_wrapper');
      }
      tv_max_offset = window.wh;
    }
    else if (
      tv_cur_block === 'tv_radiolist' ||
      tv_cur_block === 'tv_channellist' ||
      tv_cur_block === 'tv_programmes_list' ||
      tv_cur_block === 'choosing_list' ||
      tv_cur_block === 'language' ||
      tv_cur_block === 'category' ||
      tv_cur_block === 'genre'
    ) {
      tv_cur_offset_target = $('#' + tv_cur_block).find('.content');

      if (
        isset('config.tv_channellist_type') === 'mosaic' ||
        tv_cur_block === 'tv_radiolist' ||
        tv_cur_block === 'tv_programmes_list' ||
        tv_cur_block === 'genre'
      ) {
        tv_max_offset = $('#' + tv_cur_block)
          .find('.content_wrapper')
          .height();
        tv_offset_threshold =
          tv_cur_block === 'language' || tv_cur_block === 'category' || tv_cur_block === 'genre' ? 20 : 0;
      } else {
        tv_max_offset = 0;
        tv_offset_threshold = 1000;
      }
    }
    else if (tv_cur_block === 'VODplayer') {
      if (tv_cur_elem.hasClass('btn_player_lng')) {
        tv_max_offset = 0;
        tv_offset_threshold = 1000;
        tv_cur_offset_target = $('#playerListMenu');
      } else {
        tv_cur_offset_target = $(document.body);
      }
    }
    else if (tv_cur_block === 'VODcategory') {
      tv_offset_threshold = 74;
      tv_cur_offset_target = $(active_page).find('.content');
      tv_max_offset = $(active_page).find('.content_wrapper').height();
    }
    else if (tv_cur_block === 'channel') {
      if (tv_cur_elem.hasClass('btn_player_lng')) {
        tv_max_offset = 0;
        tv_offset_threshold = 1000;
        tv_cur_offset_target = tv_cur_elem.parent();
      } else {
        tv_cur_offset_target = $(document.body);
      }
    }
    else if (tv_cur_block === 'tv_welcome') {
      tv_cur_offset_target = $('#tv_welcome .container, #tv_welcome .content');
    }
    else if (tv_cur_block === 'weather_select_location') {
      container = $('#' + tv_cur_block);

      tv_cur_offset_target = container.find('.content');
      tv_max_offset = container.find('.content_wrapper').height();
      tv_offset_threshold = 20;
    }
    else if (tv_cur_block === 'popup') {
      container = $(active_page);

      tv_cur_offset_target = container.find('.content');
      tv_max_offset = container.find('.content_wrapper').height();
      tv_offset_threshold = 20;
    }
    else if (tv_cur_block === 'mod_playlist') {
      container = $('#' + MOD.current_playlist_id);

      tv_cur_offset_target = container.find('.content');
      tv_max_offset = container.find('.content_wrapper').height();
      tv_offset_threshold = 20;
    }
    else if (tv_cur_block === 'dialog') {
      tv_cur_offset_target = $('#custom_dialog_content');
      tv_max_offset = window.wh;
    }
    else if (tv_cur_block == 'keypad') {
      tv_cur_offset_target = $(document.body);
      tv_max_offset = window.wh;
    }
    else if (
      tv_cur_block === 'information_list_classic' ||
      tv_cur_block === 'shop_products_classic'
    ) {
      var contentString = '',
        contentWrapperString = '';

      if (tv_cur_elem.hasClass('sidebar-item')) {
        contentString = '.sidebar-left .content';
        contentWrapperString = '.sidebar-left .content_wrapper';
        tv_scroll_suffix = 'left';
      }
      else {
        contentString = '.sidebar-right .content';
        contentWrapperString = '.sidebar-right.content_wrapper';
        tv_scroll_suffix = 'right';
      }

      tv_cur_offset_target = $(active_page).find(contentString);
      tv_max_offset = $(active_page).find(contentWrapperString).height();
    }
    else {
      tv_cur_offset_target = $(active_page).find('.content');
      tv_max_offset = $(active_page).find('.content_wrapper').height();

      if (!tv_cur_offset_target[0]) {
        tv_cur_offset_target = $(document.body);
        tv_max_offset = tv_cur_offset_target.height();
      }
    }

    tv_cur_offset =
      tv_cur_elem.get(0).getBoundingClientRect().top - tv_cur_offset_target.get(0).getBoundingClientRect().top;

    if (tv_cur_block === 'VODplayer' || tv_cur_block === 'channel') {
      if (tv_cur_elem.hasClass('btn_player_lng')) {
        tv_cur_offset_target.css('transform', 'translate(-' + Math.round(tv_cur_elem.position().left) + 'px, 0)');
      } else {
        tv_sel_list.removeClass('tv_cur');
        tv_cur_elem.addClass('tv_cur');
      }
    }
    else if (
      tv_cur_block === 'tv_radiolist' ||
      tv_cur_block === 'tv_channellist' ||
      tv_cur_block === 'tv_programmes_list' ||
      tv_cur_block === 'language' ||
      tv_cur_block === 'category' ||
      tv_cur_block === 'genre'
    ) {
      if (tv_cur_block === 'tv_radiolist' || tv_cur_block === 'genre') {
        if (
				(
					tv_cur_pos === 0 &&
					tv_cur_block === 'genre'
				) ||
				(
					tv_cur_block === 'tv_radiolist' &&
					(
						tv_cur_pos === 0 ||
						tv_cur_pos === 1 ||
						tv_cur_pos === 2 ||
						tv_cur_pos === 3
					)
				)
        ) {
          tv_cur_offset_target[0].style.top = 0;
          move_scroll(0, tv_cur_block);
        } else {
          tv_cur_offset_target_top = tv_cur_offset_target.position().top;

          if (tv_cur_offset + tv_cur_height - 2 + tv_offset_threshold > tv_max_offset - tv_cur_offset_target_top) {
            shift = Math.min(
              0,
              Math.max(
                tv_max_offset - tv_cur_offset_target.outerHeight(true),
                tv_max_offset - (tv_cur_offset + tv_cur_height) - tv_offset_threshold,
              ),
            );

            if (tv_cur_block === 'genre') {
              tv_cur_offset_target[0].style.top = shift + 'px';
            } else {
              tv_cur_offset_target[0].style.top = -(tv_cur_offset - tv_max_offset + tv_cur_height) + 'px';
            }

            move_scroll(shift, tv_cur_block);
          } else if (tv_cur_offset < tv_offset_threshold - tv_cur_offset_target_top) {
            shift = Math.min(0, -tv_cur_offset + tv_offset_threshold);

            if (tv_cur_block === 'genre') {
              tv_cur_offset_target[0].style.top = shift + 'px';
            } else {
              tv_cur_offset_target[0].style.top = tv_cur_offset_target_top + tv_cur_height + 'px';
            }

            move_scroll(shift, tv_cur_block);
          }
        }
      } else if (
        typeof isset('config.tv_channellist_type') !== 'undefined' &&
        (isset('config.tv_channellist_type') === 'vertical' || isset('config.tv_channellist_type') === 'vertical_new')
      ) {
        tv_offset_threshold = 10;
        tv_max_offset = $('#tv_channellist_cont').height();
        if (tv_cur_offset + tv_cur_height + tv_offset_threshold > tv_max_offset - tv_cur_offset_target.position().top) {
          tv_cur_offset_target[0].style.top =
            Math.min(
              0,
              Math.max(
                tv_max_offset - tv_cur_offset_target.outerHeight(true),
                tv_max_offset - (tv_cur_elem.position().top + tv_cur_height) - tv_offset_threshold,
              ),
            ) + 'px';
        } else if (tv_cur_offset < tv_offset_threshold - tv_cur_offset_target.position().top) {
          tv_cur_offset_target[0].style.top = Math.min(0, -tv_cur_elem.position().top + tv_offset_threshold) + 'px';
        }
        var percent = Math.abs(
          tv_cur_offset_target.position().top / (tv_max_offset - tv_cur_offset_target.outerHeight(true)),
        );

        var scroll = document.getElementById('scroll_scroll');
        if (scroll) {
          scroll.style.top = Math.round(percent * ($('#scroll_inner').height() - $('#scroll_scroll').height())) + 'px';
        }
      } else if (
        typeof isset('config.tv_channellist_type') !== 'undefined' &&
        isset('config.tv_channellist_type') !== 'mosaic'
      ) {
        tv_cur_offset_target[0].style.left =
          Math.round(($('#tv_channellist_cont').width() - tv_cur_elem.width()) / 2 - tv_cur_elem.position().left) +
          'px';
      } else if (
        typeof isset('config.tv_channellist_type') !== 'undefined' &&
        isset('config.tv_channellist_type') === 'mosaic'
      ) {
        if (
          (tv_cur_block === 'tv_programmes_list' && isEpgFirstLine()) ||
          (tv_cur_pos === 0 && (tv_cur_block === 'language' || tv_cur_block === 'category'))
        ) {
          tv_cur_offset_target[0].style.top = 0;
          move_scroll(0, tv_cur_block);
        } else {
          tv_cur_offset_target_top = tv_cur_offset_target.position().top;

          tv_cur_offset = appUseZoom ? Math.ceil(tv_cur_offset) : tv_cur_offset;
          tv_cur_offset_target_top = appUseZoom ? Math.ceil(tv_cur_offset_target_top) : tv_cur_offset_target_top;

          if (tv_cur_offset + tv_cur_height - 2 + tv_offset_threshold > tv_max_offset - tv_cur_offset_target_top) {
            shift = Math.min(
              0,
              Math.max(
                tv_max_offset - tv_cur_offset_target.outerHeight(true),
                tv_max_offset - (tv_cur_offset + tv_cur_height) - tv_offset_threshold,
              ),
            );

            if (tv_cur_block === 'language' || tv_cur_block === 'category') {
              tv_cur_offset_target[0].style.top = shift + 'px';
            } else {
              tv_cur_offset_target[0].style.top = -(tv_cur_offset - tv_max_offset + tv_cur_height) + 'px';
            }

            move_scroll(shift, tv_cur_block);
          } else if (tv_cur_offset < tv_offset_threshold - tv_cur_offset_target_top) {
            shift = Math.min(0, -tv_cur_offset + tv_offset_threshold);

            if (tv_cur_block === 'language' || tv_cur_block === 'category') {
              tv_cur_offset_target[0].style.top = shift + 'px';
            } else {
              tv_cur_offset_target[0].style.top = tv_cur_offset_target_top + tv_cur_height + 'px';
            }

            move_scroll(shift, tv_cur_block);
          }
        }
      }
    }
    else if (tv_cur_block === 'weather_select_location') {
      if (tv_cur_pos === 0) {
        tv_cur_offset_target[0].style.top = 0;
        move_scroll(0, 'substrate');
      } else {
        tv_cur_offset_target_top = tv_cur_offset_target.position().top;

        if (tv_cur_offset + tv_cur_height + tv_offset_threshold > tv_max_offset - tv_cur_offset_target_top) {
          shift = Math.min(
            0,
            Math.max(
              tv_max_offset - tv_cur_offset_target.outerHeight(true),
              tv_max_offset - (tv_cur_offset + tv_cur_height) - tv_offset_threshold,
            ),
          );

          tv_cur_offset_target[0].style.top = -(tv_cur_offset - tv_max_offset + tv_cur_height) + 'px';
          move_scroll(shift, 'substrate');
        } else if (tv_cur_offset < tv_offset_threshold - tv_cur_offset_target_top) {
          shift = Math.min(0, -tv_cur_offset + tv_offset_threshold);
          tv_cur_offset_target[0].style.top = tv_cur_offset_target_top + tv_cur_height + 'px';
          move_scroll(shift, 'substrate');
        }
      }
    }
    else if (tv_cur_block === 'tv_welcome') {
      tv_sel_list.removeClass('tv_cur');
      tv_cur_elem.addClass('tv_cur');
    }
    else if (tv_cur_block === 'menu' && scandic_menu) {
      if (tv_cur_pos === previousPosition.get()) {
        return false;
      }

      var tvCurPositionX = isset('config.tv.hacks.tv_cursor_no_transform')
          ? parseInt(tv_cur.style.left)
          : parseInt(matrixToArray($(tv_cur).css('transform'))[4]),
        ITEM_MARGIN_RIGHT = 25,
        ITEM_WIDTH = 210,
        VISIBLE_ITEMS = 5,
        positionLeft,
        positionPrev;

      if (tv_cur_pos === 0) {
        positionLeft = 0 + 'px';
      } else if (tvCurPositionX > 1000 && tv_cur_pos - previousPosition.get() > 0) {
        positionLeft = -((tv_cur_pos + 1 - VISIBLE_ITEMS) * (ITEM_WIDTH + ITEM_MARGIN_RIGHT)) + 'px';
      } else if (tvCurPositionX < 100 && tv_cur_pos - previousPosition.get() < 0) {
        positionLeft = -(tv_cur_pos * (ITEM_WIDTH + ITEM_MARGIN_RIGHT)) + 'px';
      }

      positionPrev = tv_cur_offset_target[0].style.left;

      if (typeof positionLeft === 'undefined') {
        positionLeft = positionPrev;
      }

      cursorMovingPermitted.set({
        key: 'scandic_menu',
        direct: tv_cur_pos > previousPosition.get() ? 'right' : 'left',
        animation: positionPrev !== positionLeft,
        time: 200,
      });

      // управление opacity стрелок
      Menu.setScandicMenuArrowOpacity();

      if (
        // если перемещаем меню, не перемещаем tv_cur
        positionPrev !== positionLeft &&
        // когда возвращаемся со страницы в меню
        // tv_cur скрыт
        // это вызывает сдвиг меню влево
        tvCurPositionX !== 0
      ) {
        tv_cur_offset_target[0].style.left = positionLeft;

        return false;
      }
    }
    else if (!btn_move) {
      if (tv_cur_block === 'cart' || tv_cur_block === 'feedback') {
        if (tv_cur_pos === 0) {
          shift = 0;
          tv_cur_offset_target[0].style.top = 0;

          move_scroll(shift);
        } else {
          tv_cur_offset_target_top = tv_cur_offset_target.position().top;
          if (tv_cur_offset + tv_cur_height + tv_offset_threshold > tv_max_offset - tv_cur_offset_target_top) {
            shift = Math.min(
              0,
              Math.max(
                tv_max_offset - tv_cur_offset_target.outerHeight(true),
                tv_max_offset - (tv_cur_offset + tv_cur_height) - tv_offset_threshold,
              ),
            );

            if (!tv_cur_offset_target.find('.gallery_container').length) {
              tv_cur_offset_target[0].style.top = shift + 'px';
            }

            move_scroll(shift);
          } else if (tv_cur_offset < tv_offset_threshold - tv_cur_offset_target_top) {
            shift = Math.min(0, -tv_cur_offset + tv_offset_threshold);
            tv_cur_offset_target[0].style.top = shift + 'px';

            move_scroll(shift);
          }
        }
      } else if (
        tv_cur_block === 'toppings' ||
        ((tv_cur_block === 'order_details' || tv_cur_block === 'orders') && tv_sel_list.length > 1) ||
        (!tv_cur_elem.hasClass('button') && !tv_cur_elem.hasClass('shop_plusminus'))
      ) {
        if (tv_cur_pos === 0 && tv_cur_block !== 'VODcategory') {
          shift = 0;
          tv_cur_offset_target[0].style.top = 0;

          move_scroll(shift, undefined, tv_scroll_suffix);
        } else {
          // NOTE: This code block is responsible for automatically scrolling the container so that the selected element is always visible.
          tv_cur_offset_target_top = tv_cur_offset_target.position().top;

          if (tv_cur_offset + tv_cur_height + tv_offset_threshold >= tv_max_offset - tv_cur_offset_target_top) {
            shift = Math.min(
              0,
              Math.max(
                tv_max_offset - tv_cur_offset_target.outerHeight(true),
                tv_max_offset - (tv_cur_offset + tv_cur_height) - tv_offset_threshold,
              ),
            );

            if (!tv_cur_offset_target.find('.gallery_container').length) {
              tv_cur_offset_target[0].style.top = shift + 'px';
            }

            move_scroll(shift, undefined, tv_scroll_suffix);
          } else if (tv_cur_offset < tv_offset_threshold - tv_cur_offset_target_top) {
            shift = Math.min(0, -tv_cur_offset + tv_offset_threshold);

            tv_cur_offset_target[0].style.top = shift + 'px';

            move_scroll(shift, undefined, tv_scroll_suffix);
          }
        }
      }
    }

    setPositionTvCur();
  }

  function setOrderNumberCursorPosition(number) {
    tv_cur_pos = number;
    tv_sel_cur();
  }

  function setPositionTvCur() {
    $('.tv_cur').removeClass('tv_cur');
    tv_cur_elem.addClass('tv_cur');

    // New desktop Chromium zoom standart fix
    var coef = 1;
    if (
      appUseZoom != false &&
      ((ua.match(/chrome\/(\d+)/) && ua.match(/chrome\/(\d+)/)[1] >= 128) ||
        (ua.match(/edg\/(\d+)/) && ua.match(/edge\/(\d+)/)[1] >= 128) ||
        (ua.match(/firefox\/(\d+)/) && ua.match(/firefox\/(\d+)/)[1] >= 129))
    ) {
      coef = 1 / appUseZoom;
    }
    // ----

    var out_size = isset('config.cursor.out_size', 2),
      in_size = isset('config.cursor.in_size', 1), // TV_CUR border is 1px
      // inside and 2px
      // outside
      full_size = out_size + in_size,
      tmp = tv_cur_elem.get(0).getBoundingClientRect(),
      tmp_top = tmp.top * coef - out_size,
      tmp_left = tmp.left * coef - out_size,
      tmp_width = tmp.width * coef - 2 * in_size,
      tmp_height = tmp.height * coef - 2 * in_size;

    //left border
    if (tmp_left <= 0) {
      tmp_width += tmp_left;
      tmp_left = 0;
    }
    //right border
    if (tmp_left + tmp_width + 2 * full_size > window.ww) {
      tmp_width -= out_size;
    }
    //top border
    if (tmp_top <= 0) {
      tmp_height += tmp_top;
      tmp_top = 0;
    }
    //bottom border
    if (tmp_top + tmp_height + 2 * full_size >= window.wh) {
      tmp_height -= out_size;
    }

    if (cursorIsNotVisible(tmp_top)) {
      return false;
    }

    var tv_cur_style = document.getElementById('tv_cur').style;
    tv_cur_style.width = tmp_width + 'px';
    tv_cur_style.height = tmp_height + 'px';

    if (typeof previousPosition.get('channel') !== 'undefined') {
      return false;
    }

    if (isset('config.tv.hacks.tv_cursor_no_transform')) {
      tv_cur_style.left = tmp_left + 'px';
      tv_cur_style.top = tmp_top + 'px';
    } else {
      //tv_cur_style.webkitTransform = 'translate3D( ' + tmp_left+'px, '+ tmp_top + 'px,0)';
      tv_cur_style.webkitTransform = 'translate( ' + tmp_left + 'px, ' + tmp_top + 'px)';
      tv_cur_style.transform = 'translate( ' + tmp_left + 'px, ' + tmp_top + 'px)';
    }

    // TODO: Sometimes tvPrevCurElem's trigger method is undefined,
    // check it and maybe place this logic somewhere else
    // NOTE: it's supposed event_action_leave triggered before event_action_move
    if (tvPrevCurElem && tvPrevCurElem.trigger) {
      tvPrevCurElem.trigger(event_action_leave);
    }
    tv_cur_elem.trigger(event_action_move);

    tv_cur_style.display = tv_cur_elem.hasClass('not_tv_cur') ? 'none' : 'block';

    function cursorIsNotVisible(elemTop) {
      // TODO: needs improvement
      // Disable this function in shop items, because .content_wrapper has lower position than buttons,
      // needs rethinking and refactoring
      if (
        tv_cur_block === 'shopitem' ||
        tv_cur_block === 'settings' ||
        tv_cur_block === 'scroll' ||
        tv_cur_block === 'fullscreen_video'
      ) {
        return false;
      }

      // Check if cursor in overlay's element
      if (tv_cur_elem.parents('#tv_overlay_wrapper').length > 0) {
        return false;
      }

      var visibleArea;
      try {
        visibleArea = tv_cur_offset_target.parent();
      } catch (e) {
        return false;
      }

      if (!visibleArea) {
        return false;
      }

      var visibleAreaTop = visibleArea[0].getBoundingClientRect().top;
      return visibleAreaTop >= elemTop + 20;
    }
  }

  function tv_sel_block(id) {
    var tmp;
    id = getID(id);

    previousBlock = tv_cur_block;

    if (tv_sel_list.length) {
      tv_sel_list.removeClass('tv_sel');
    }

    if (tv_cur_elem && tv_cur_elem.length) {
      tv_cur_elem[0].classList.add('tv_sel');
    }

    setActiveNavItem(id);

    // выбор языка в tv_mosaic при tv_cur_block == channel
    if (
      id === 'channel' &&
      guestData.tv_channels_lang_stream &&
      guestData.tv_channels_lang_stream[tv_mosaic.current_channel] != null
    ) {
      tv_cur_pos = guestData.tv_channels_lang_stream[tv_mosaic.current_channel];
    } else {
      tv_cur_pos = 0;
    }

    $('#tv_cur').removeClass('square');
    if (id === 'menu') {
      tv_cur_block = 'menu';
      tv_sel_list = $('#menu')
        .find('[href]')
        .filter(function () {
          return $(this).is(':visible') && this.tagName.toLowerCase() !== 'use';
        });
      metro_menu_calc();
      $('#tv_cur').addClass('square');
    }
    else if (id === 'dialog') {
      tv_cur_block = 'dialog';
      tv_sel_list = $('#custom_dialog')
        .find('[onvclick]')
        .filter(function () {
          return $(this).is(':visible');
        });
      metro_menu_calc();
    }
    else if (id === 'show_gallery') {
      tv_cur_block = 'show_gallery';
      tv_sel_list = $('.gallery_subContainer').find('[onvclick]');
      tv_cur_elem = tv_sel_list;
      $('#tv_cur').addClass('square');
      return true;
    }
    else if (id === 'guide') {
      tv_cur_block = 'guide';
      tv_sel_list = $('#' + id).find('.guide_icon');
    }
    else if (
      id === 'settings' ||
      id === 'service_page' ||
      id === 'select_page' ||
      id === 'language_select' ||
      id === 'selectpage' ||
      id === 'sources_list' ||
      id === 'sample_page'
    ) {
      tv_cur_block = 'settings';
      tv_sel_list = $('#' + id)
        .find('.content')
        .find('[href^="#"], [onvclick]')
        .filter(function () {
          return $(this).is(':visible');
        });
    } else if (id === 'tv_mosaic' || id === 'tv_channellist') {
      tv_cur_block = 'tv_channellist';
      tv_sel_list = $('#tv_channellist')
        .find('.content')
        .find('li')
        .filter(function (index, item) {
          return isset('config.tv_channellist_type') === 'not_vertical' ||
            isset('config.tv_channellist_type') === 'vertical' ||
            isset('config.tv_channellist_type') === ''
            ? true
            : $(item).is(':visible');
        });
    }
    else if (id === 'tv_programmes_list') {
      tv_cur_block = 'tv_programmes_list';
      tv_sel_list = $('#tv_programmes_list').find('.programme');
    }
    else if (id === 'language' || id === 'category' || id === 'genre') {
      tv_cur_block = id;
      tv_sel_list = $('#' + id)
        .find('.content')
        .find('li');
    }
    else if (id === 'tv_radiolist') {
      tv_cur_block = 'tv_radiolist';
      tv_sel_list = $('#tv_radiolist')
        .find('.content')
        .find('li')
        .filter(function (index, item) {
          return !$(item).hasClass('displaynone');
        });
    }
    else if (id === 'channel') {
      tv_cur_block = 'channel';
      tv_sel_list = $('#bottom_channel_information').find('[data-code]');
    }
    else if (id === 'keypad') {
      tv_cur_block = 'keypad';
      tv_sel_list = $('#hoteza_keypad TD');
      metro_menu_calc();
    }
    else if ($('#' + id).hasClass('service_page')) {
      tv_cur_block = 'shopitem';
      tv_sel_list = $(active_page)
        .find('.shop_plusminus, DIV.button, #shopitemoptions .settings_button')
        .filter(function () {
          return $(this).is(':visible');
        });
      metro_menu_calc();
    }
    else if (id === 'shopitem' || id === 'order_details' || id === 'orders') {
      tv_cur_block = id;
      tv_sel_list = $(active_page)
        .find('.shop_plusminus, .button, #shopitemoptions .settings_button')
        .filter(function () {
          return $(this).is(':visible');
        });
      metro_menu_calc();
    }
    else if (id === 'cart') {
      tv_cur_block = 'cart';
      tv_sel_list = $('#cart')
        .find('[onvclick], .shop_plusminus')
        .filter(function () {
          return $(this).is(':visible');
        });
    }
    else if (id === 'feedback') {
      tv_cur_block = 'feedback';
      tv_sel_list = $('#feedback')
        .find('[href], [onvclick]')
        .filter(function () {
          return $(this).is(':visible');
        });
    }
    else if (id === 'tv_welcome') {
      //TODO: перенести в navigate
      active_page = '#tv_welcome';
      active_page_id = 'tv_welcome';
      tv_cur_block = 'tv_welcome';
      tv_sel_list = $('#tv_welcome [onvclick]');
    }
    else if (id === 'weather_select_location') {
      tv_cur_block = 'weather_select_location';
      tv_sel_list = $('#weather_select_location')
        .find('[onvclick]')
        .filter(function () {
          return $(this).is(':visible');
        });
    }
    else if (id === 'VODplayer') {
      tv_cur_block = 'VODplayer';
      tv_sel_list = $('#playerPanel [onvclick]').filter(function () {
        return $(this).is(':visible');
      });
    }
    else if (id === 'VODcategory') {
      tv_cur_block = 'VODcategory';
      tv_sel_list = $('#' + id)
        .find('.pagelist')
        .find('[onvclick]')
        .filter(function () {
          return $(this).is(':visible');
        });
      metro_menu_calc();
    }
    else if (id === 'time_picker') {
      tv_cur_block = 'time_picker';
      tv_sel_list = $('#time_picker')
        .find('[onvclick], .time_picker_item, .button')
        .filter(function () {
          return $(this).is(':visible');
        });
      tv_keydown_override = time_picker.server_keydown;
    }
    else if ($id(id) && $id(id).classList.contains('list_items_toppings')) {
      tv_cur_block = 'toppings';
      tv_sel_list = $(active_page)
        .find('.shop_plusminus, .shop_radio, .shop_select, .button')
        .filter(function () {
          return $(this).is(':visible');
        });
    }
    else if ($id(id) && $id(id).classList.contains('popup')) {
      tv_cur_block = 'popup';
      tv_sel_list = $('#' + id)
        .find('[onvclick], .button')
        .filter(function () {
          return $(this).is(':visible');
        });
    }
    else if (
      id === 'mod_playlist' ||
      ($id(id) && $id(id).classList.contains('mod_playlist'))
    ) {
      tv_cur_block = 'mod_playlist';
      tv_sel_list = id === 'mod_playlist' ? $(active_page).find('li') : $('#' + id).find('li');
    }
    else if ($id(id) && $id(id).classList.contains('fullscreen_video')) {
      tv_cur_block = 'fullscreen_video';
      tv_sel_list = $([]);
    }
    else if ($id(id) && $id(id).classList.contains('shop_products_classic')) {
      tv_cur_block = 'shop_products_classic';
      tv_sel_list = $([]);
    }
    else if ($('#' + id).find('.pagelist.shop').length) {
      tv_cur_block = 'pagelist';
      tv_sel_list = $('#' + id)
        .find('.pagelist')
        .find('[onvclick]')
        .filter(function () {
          return $(this).is(':visible');
        });
      metro_menu_calc();
    }
    else if ($('#' + id).find('.rcu').length) {
      tv_cur_block = 'pagelist';
      tv_sel_list = $('#' + id)
        .find('.rcu')
        .filter(function () {
          return $(this).is(':visible');
        });
      metro_menu_calc();
    }
    else if ($id(id) && $id(id).classList.contains('information_list_classic')) {
      tv_cur_block = 'information_list_classic';
      tv_sel_list = $([]);
    }
    else if ($id(id) && (tmp = $id(id).querySelector('.pagelist'))) {
      tv_cur_block = 'pagelist';
      tv_sel_list = $(tmp)
        .find('[href]')
        .filter(function () {
          return $(this).is(':visible');
        });
      metro_menu_calc();
      if (['sources_page'].indexOf(id) == -1) {
        $('#tv_cur').addClass('square');
      }
    }
    else if ($('#' + id).find('.gallery_container').length) {
      tv_cur_block = 'gallery';
      tv_sel_list = $('#' + id).find('IMG');
      $('#tv_cur').hide();
      $('#tv_cur').addClass('square');
    }
    else if (id === 'shop_order' || id === 'movie_page' || id === 'viewbill') {
      tv_cur_block = 'service_page';
      tv_sel_list = $('#' + id)
        .find('[href^="#"], [onvclick], .timepicker')
        .filter(function () {
          return $(this).is(':visible');
        });
    }
    else if ($('#' + id).hasClass('weather')) {
      //Статичная страница
      tv_cur_block = 'static';
      tv_sel_list = $([]);
    }
    else {
      tv_sel_list = $('#' + id)
        .find('[href^="#"], [onvclick], .timepicker, DIV.button')
        .filter(function () {
          return $(this).is(':visible');
        });
      if (tv_sel_list.length) {
        tv_cur_block = 'settings';
      } else {
        tv_cur_block = 'scroll';
        tv_sel_list = $([]);
      }
    }

    var selectableElems = $('#' + id + ' [selectable]').filter(function () {
      return $(this).is(':visible');
    });

    if (selectableElems.length) {
      tv_sel_list = tv_sel_list.add(selectableElems);

      metro_menu_calc();
    }

    var overlayWrapper = $('#tv_overlay_wrapper');
    if (
      overlayWrapper.length &&
      (
        id !== 'dialog' && id !== 'notification_container' && id !== 'popup'
      )
    ) {
      Menu.serveOverlayBlocks(window.tv_cur_block);

      var overlayInteractiveItems = overlayWrapper
        .find('[href], [selectable]')
        .filter(function () {
            return $(this).is(':visible');
        });

      if (overlayInteractiveItems.length) {
        tv_sel_list = tv_sel_list.add(overlayInteractiveItems);
        metro_menu_calc(tv_sel_list, true);
      }
    }

    tv_cur_pos = getTvCurPos();

    tv_max_pos = tv_sel_list.length;
    tv_sel_cur();

    if ($('#' + id).find('.back').length) {
      $('#tv_fullscreen_btn_back').show();
    } else {
      $('#tv_fullscreen_btn_back').hide();
    }

    // обработка видео на страницах и меню
    videoControl();

    function getID(page_id) {
      if (page_id) {
        return page_id;
      }
      if (['tv_radiolist', 'genre'].indexOf(previousBlock) != -1) {
        return previousBlock;
      }
      if (fullscreen) {
        return isset('config.tv_channellist_type') === 'mosaic' && tv_mosaic.current_block
          ? tv_mosaic.current_block
          : 'tv_channellist';
      }

      if (Menu.opened) {
        return 'menu';
      }

      return active_page_id;
    }

    function videoControl() {
      var pageId = isGetVideoPage();
      if (pageId === null) {
        $(document.body).removeClass('video');
        $('#container').css('background', '');

        return false;
      }

      var video = videoCollection.get();
      if (video && !video.paused && video.page === pageId) {
        $(document.body).addClass('video');
        return false;
      } else if (video && video.isUnstoppable()) {
        return false;
      }

      video = new Video(pageId);
      if (video.getVideo()) {
        $(document.body).addClass('video');
        var page = getPageFromStruct(pageId);
        // Information.background contains bg with a small hole; that's why we check !page.imageWide
        if (page.video && !page.imageWide) {
          $('#container').css('background', 'url("' + Information.background + '")');
        }
        videoCollection.add(pageId, video);
      } else {
        $(document.body).removeClass('video');
        $('#container').css('background', '');
      }

      setTimeout(videoCollection.start, 100);
    }

    function getTvCurPos() {
      if (tv_cur_block === 'tv_programmes_list') {
        return Epg.getCurrentItemPosition();
      }

      if (tv_sel_list.filter('.tv_sel').length) {
        return tv_sel_list.index(tv_sel_list.filter('.tv_sel'));
      }

      return tv_cur_pos;
    }
  }

  function change_sel_list(direct) {
    switch (tv_cur_block) {
      case 'tv_welcome':
        var welcome_block = $('#tv_welcome');

        switch (direct) {
          case 'up':
            if (!tv_cur_elem.hasClass('btn_lng')) {
              break;
            }

            tv_sel_list.removeClass('tv_cur');
            tv_sel_block('tv_welcome');

            break;
          case 'down':
            if (!tv_cur_elem.hasClass('button')) {
              break;
            }

            tv_sel_list = welcome_block.find('.btn_lng');

            if (!tv_sel_list.length) {
              tv_sel_block('tv_welcome');
              break;
            }

            tv_cur_elem = welcome_block.find('.current_language');
            tv_max_pos = tv_sel_list.length;
            tv_cur_pos = tv_cur_elem.index();

            break;
        }

        break;
    }
  }

  function tv_ok() {
    if (fullscreen) {
      if (tv_channellist_hidden) {
        tv_channellist_show(true);
        tv_sel_cur();
      } else {
        if (tv_cur_elem) {
          tv_cur_elem.trigger(event_link);
        }
      }
    } else {
      if (tv_sel_list.length && tv_cur_elem) {
        if (tv_cur_block === 'VODplayer') {
          if (VOD.playerVisible) {
            tv_cur_elem.trigger(event_link);
          } else {
            VOD.show();
          }
        } else {
          tv_cur_elem.trigger(event_link);
        }
      }
    }
  }

  function tv_chup() {
    if (fullscreen) {
      tv_right();
      tv_ok();
    } else {
      if (tv_cur_block === 'shopitem') {
        shop_plus();
      }
    }
  }

  function tv_chdown() {
    if (fullscreen) {
      tv_left();
      tv_ok();
    } else {
      if (tv_cur_block === 'shopitem') {
        shop_minus();
      }
    }
  }

  function tv_menu(fromPage) {
    fromPage = fromPage && fromPage.length ? fromPage : null;
    if (fromPage) {
      fromPage.hide();
      fromPage.removeClass('active_page away_page l r');
    }

    if (tv_cur_block === 'dialog') {
      //Скрытие алерта
      custom_dialog_close();
    } else if (tv_cur_block === 'VODplayer') {
      VOD.destroy();
      //TODO: вынести в override
      tv_menu();
    } else if ('VOD' in window && VOD.active && tv_cur_block === 'menu') {
      VOD.close();
    }
  }

  function tv_back() {
    if (!fullscreen) {
      if (tv_cur_block === 'dialog') {
        //Скрытие алерта
        custom_dialog_close();
      } else if (tv_cur_block === 'VODplayer') {
        if (VOD.playerVisible) {
          if (VOD.playerDOM.paused) {
            clearTimeout(VOD.hideTimer);
            VOD.destroy();
            return;
          }

          VOD.hide();
        } else {
          VOD.destroy();

          // для HG32EE590
          _tv_bg_restore();
        }
      } else if ('VOD' in window && VOD.active && tv_cur_block === 'menu') {
        VOD.close();
      } else if (tv_cur_block === 'tv_welcome') {
        tv_welcome_hide();
      } else if (tv_cur_block !== 'menu') {
        // manageShadowOnPage({ id: 'shopitem', remove: true });

        var tmp = $(active_page).find('.back[href_type=back]');
        if (tmp.length) {
          tmp.trigger(event_link);
        } else {
          navigateBack();
        }
      }
    } else {
      if (isset('config.tv_channellist_type') === 'vertical_new') {
        VerticalChannel.back();
      } else {
        if (!tv_channellist_hidden) {
          tv_channellist_hide(true);
        } else {
          tv_mode();
        }
      }
    }
  }

  window.previousBlock = undefined;

  window.tv_keydown = tv_keydown;
  window.scrollPage = scrollPage;
  window.tv_up = tv_up;
  window.tv_down = tv_down;
  window.move_scroll = move_scroll;
  window.tv_left = tv_left;
  window.tv_right = tv_right;
  window.tv_sel_cur = tv_sel_cur;
  window.setPositionTvCur = setPositionTvCur;
  window.tv_sel_block = tv_sel_block;
  window.change_sel_list = change_sel_list;
  window.tv_ok = tv_ok;
  window.tv_chup = tv_chup;
  window.tv_chdown = tv_chdown;
  window.tv_menu = tv_menu;
  window.tv_back = tv_back;
  window.setOrderNumberCursorPosition = setOrderNumberCursorPosition;
})();

(function () {
  function hideForTvMode(channelId) {
    //TODO: video_channels заменить на video после фикса videoControl
    $(document.body).addClass('video_channels');

    $('#container').hide();

    if (isset('config.tv_channellist_type') === 'mosaic') {
      //Хак для скандик меню, не убиралось приветствие гостя при переходе на каналы из главного меню (нужно только для
      // мозаики?)
      if (scandic_menu) {
        if (channelId === undefined) {
          hide_menu();
        }
      }
      //----
    }
  }

  /**
   * Включает канал, если уже находишься в TV mode.
   * Сначала ищет канал по ID. Если канал с таким ID не найден,
   * трактует переданное значение как индекс канала в списке.
   * @param {string|number} channelIdOrIndex - ID канала или его индекс в списке каналов
   * @returns {boolean|undefined} false, если канал не найден ни по ID, ни по индексу
   */
  function turnOnChannelInTvMode(channelIdOrIndex) {
    var channel = getChannelIndexById(channelIdOrIndex);
    if (typeof channel === 'undefined') {
      if (!getChannels()[channelIdOrIndex]) {
        return false;
      }
      channel = channelIdOrIndex;
    }

    tv_channellist_show();
    tv_channel_show(channel);

    if (typeof channel === 'number') {
      if (isset('config.tv_channellist_type') === 'mosaic') {
        tv_mosaic.channel(channel, 'channel');
        return true;
      }

      tv_cur_pos = channel;
      tv_sel_cur();
    }
  }

  /**
   * Switches to TV mode.
   * @param {string} [channelId] - The ID of the channel to turn on immediately after entering TV mode.
   * This parameter is useful as it allows switching directly to a specific channel upon entering TV mode.
   * Note: The channelId functionality is currently implemented only for tv_mosaic.
   */
  function tv_mode(channelId) {
    if (!tv_channels.length || (_tv_channels && !_tv_channels.length)) {
      custom_dialog('alert', getlang('tv_nottelevision'), getlang('not_available_channels'));
      return false;
    }

    //TODO: сделать нормально
    if (tv_cur_block === 'tv_welcome') {
      return false;
    }

    if (!fullscreen) {
      Media.stop({directType: 'ip', shutdown: true}).done(toChannel);
    } else {
      $(document.body).removeClass('video_channels');

      if (isset('config.tv_channellist_type') === 'mosaic') {
        tv_mosaic.close();
      } else {
        tv_channellist_fade(true);
        tv_channellist_hide();
      }

      $('#tv_fullscreen_overlay').removeClass('fullscreen').show();

      fullscreen = false;

      $('#tv_fullscreen_btn_tvmode').html(getlang('tv_television'));
      $('#tv_fullscreen_btn_tvcategories').hide();

      try {
        _tv_bg_restore();
      } catch (e) {}

      $('#container').show();
      // $(active_page).show();
      navigateBack();

      $('#tv_cur').css('visibility', 'visible');
    }

    function toChannel() {
      if (typeof tv_cur_channel === 'undefined') {
        tv_cur_pos = 0;
        tv_cur_channel = 0;
      }

      if (channelId === undefined) {
        hideForTvMode();
      }

      if (tv_cur_block === 'dialog') {
        //Скрытие алерта
        custom_dialog_close();
      }

      $('#tv_fullscreen_overlay').addClass('fullscreen');

      try {
        _tv_bg_prepare();
      } catch (e) {
        tv_log('bg prepare error');
      }

      navigate('#tv_mosaic');

      tv_sel_block('tv_channellist');

      // передаем управление в tv_mosaic
      if (isset('config.tv_channellist_type') === 'mosaic') {
        tv_mosaic.open(channelId);
        fullscreen = true;
        return true;
      }

      if (isset('config.tv_channellist_type') === 'vertical_new') {
        VerticalChannel.open('channel');
        fullscreen = true;
        return true;
      }

      setTimeout(tv_channellist_show, 0);

      $('#tv_fullscreen_btn_tvmode').html(getlang('tv_nottelevision'));
      if (tv_channel_categories.length > 0) {
        $('#tv_fullscreen_btn_tvcategories').show();
      }

      $('#tv_cur').css('visibility', 'hidden');

      setTimeout(function () {
        tv_channel_show(tv_cur_channel);
        fullscreen = true;
      }, 0);

      if (tv_mag_mark) {
        _player_resize();
      }
    }
  }

  window.hideForTvMode = hideForTvMode;
  window.turnOnChannelInTvMode = turnOnChannelInTvMode;
  window.tv_mode = tv_mode;
})();

(function () {
  function _filterChannelsByGroups(channels, guestGroups) {
    return channels.filter(function (channel) {
      if (!channel.groups || !channel.groups.length) {
        return true;
      }
      if (!guestGroups) {
        return false;
      }
      var tmp_intersect = channel.groups.filter(function (n) {
        return guestGroups.indexOf(n.toString()) !== -1;
      });
      return tmp_intersect.length;
    });
  }

  /**
   * Filters channels based on channel groups and guest groups.
   *
   * @param {Array} channels - The array of channels to filter.
   * @returns {Array} The filtered array of channels.
   */
  function filterChannelsByGuestGroups(channels) {
    tv_channel_filter.groups = true;
    return _filterChannelsByGroups(channels, isset('guestData.groups'));
  }

  window.filterChannelsByGuestGroups = filterChannelsByGuestGroups;
})();

(function () {
  // TODO refactor aray to channel-service
  function _sortChannelsByLanguage(channels, lang, withoutPrepareMosaic) {
    var sorted_channels = [];
    var copy_tv_channels = copyArr(channels);

    if (!withoutPrepareMosaic && isset('config.tv.channel_sorting')) {
      for (let i = 0; i < copy_tv_channels.length; i++) {
        var channelLanguages = copy_tv_channels[i].language;

        if (channelLanguages.length === 0 || channelLanguages.indexOf(lang) === -1) {
          continue;
        }

        sorted_channels.push(copy_tv_channels.splice(i, 1)[0]);
        i--;
      }
    }

    return sorted_channels.concat(copy_tv_channels);
  }

  function sortChannelsByLanguage(channels, withoutPrepareMosaic) {
    // TODO refactor to locale chain from I18nService
    var pmsLang = get_language('pms');

    return _sortChannelsByLanguage(channels, pmsLang, withoutPrepareMosaic);
  }

  window.sortChannelsByLanguage = sortChannelsByLanguage;
})();

(function () {
  var tv_fade_timer; // private

  function tv_channellist_build() {
    var channels = getChannels();
    var tmp, filtersNames, num, filtered, action;
    if (typeof channels === 'undefined') {
      return false;
    }

    if (
      tv_manufacturer == 'mag' &&
      typeof isset('config.tv_channellist_type') !== 'undefined' &&
      isset('config.tv_channellist_type') === 'mosaic' &&
      !isset('config.tv.hacks.MAG')
    ) {
      window.config.tv_channellist_type = '';
    }

    if (isset('config.tv_channellist_type') === 'vertical_new') {
      VerticalChannel.init(true);
    } else if (isset('config.tv_channellist_type') === 'vertical') {
      var h, w;
      if (!$('#tv_channellist').length) {
        $(document.body).append(
          '' +
            '<div id="tv_channellist" style="display:none;" class="vertical">' +
            '<div id="tv_channel_filter"><span>&nbsp;</span></div>' +
            '<div id="tv_channellist_cont">' +
            '<div class="content">' +
            '<ul></ul>' +
            '</div>' +
            '<div id="scroll_outer">' +
            '<div class="scroll_up"></div>' +
            '<div class="scroll_down"></div>' +
            '<div id="scroll_inner">' +
            '<div id="scroll_scroll"></div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '<div id="tv_header"></div>' +
            '</div>',
        );

        //CSS OVERRIDE
        h = window.wh - 300;
        w = 400;
        $('#tv_channellist').css('bottom', 150 + 'px');
        $('#tv_channellist_cont').height(h).width(w);
      }

      $('#tv_channellist UL').removeClass('tv_channel_category').empty();

      tmp = '';
      filtersNames = channelCategories.getNamesFiltersList();
      if (filtersNames.length) {
        $('#tv_channel_filter')
          .html(
            '<span>' +
              getlang('tv_category') +
              ': ' +
              $.each(filtersNames, function (item) {
                return item;
              }) +
              '</span>',
          )
          .show();
      } else {
        $('#tv_channel_filter').hide();
      }

      for (const num in channels) {
        // проверка tv_rights
        if (!filterRightsContent(channels[num], 'video')) {
          if (typeof tv_cur_channel === 'undefined') {
            tv_cur_channel = num;
          }

          filtered = true;
          channelCategories(channels[num], tv_channel_categories);

          if (filtersNames.length && filtersNames.indexOf(channels[num].category) === -1) {
            filtered = false;
          }
          if (typeof tv_channel_filter.language !== 'undefined' && tv_channel_filter.language !== channels[num].lang) {
            filtered = false;
          }

          // проверка nopost
          action = handlerNopost(channels, num, 'tv_channel_show(' + num + ');');
          if (filtered === true) {
            tmp +=
              '' +
              '<li data-num="' +
              num +
              '" onvclick="' +
              action +
              '">' +
              '<div class="tv_channel_logo" style="background:url(' +
              channels[num].image +
              ') 50% no-repeat;"></div>' +
              '<div class="prognum">' +
              ((num | 0) + 1) +
              '</div>' +
              channels[num].name +
              '</li>';
          }
        }
      }
      $('#tv_channellist_cont UL').append(tmp);

      //Высота контента
      var max_height = $('#tv_channellist_cont').height(),
        target_height = $('#tv_channellist LI').length * $('#tv_channellist LI').outerHeight(true) + 20;
      $('#tv_channellist').find('.content')[0].style.height =
        (target_height < max_height ? max_height : target_height) + 'px';

      if (max_height >= $('#tv_channellist_cont .content').height()) {
        $('#tv_channellist_cont UL').css('margin-right', '');
        $('#scroll_outer').hide();
      } else {
        $('#tv_channellist_cont UL').css('margin-right', '32px');
        $('#scroll_outer').height(h - 40);
        $('#scroll_outer').show();
      }

      if (fullscreen && !tv_channellist_hidden) {
        tv_sel_block('tv_channellist');
      }

      sendChannelsToMobile();
    } else if (isset('config.tv_channellist_type') === 'mosaic') {
      if (typeof tv_mosaic === 'undefined') {
        return;
      }

      tv_channel_filter.category = [];
      tv_channel_filter.language = [];

      _tv_channels = tv_mosaic.prepare_channels_for_mosaic();

      // создаем список категорий и добавляем количество каналов
      tv_channels_category_list = tv_mosaic.category_list();

      // сортируем список языков и добавляем количество каналов
      tv_channels_sorted_lang = tv_mosaic.sort_languages();

      tv_mosaic.filter_channels();

      tv_mosaic.build_container();

      if (channels.length) {
        tv_mosaic.build_channel_list();
        tv_mosaic.build_channel_list(true);

        tv_mosaic.build_preview(channels[0].name);
        tv_mosaic.build_choosing_list('language');
        tv_mosaic.build_choosing_list('category');
      }

      var tmp_preload = new PreloadMedia('#tv_channellist');
    } else {
      if (!document.getElementById('tv_channellist')) {
        $(document.body).append(
          '<div id="tv_channellist" class="horizontal" style="display:none;"><div id="tv_channel_filter"><span></span></div><div class="tv_channel_left"></div><div id="tv_channellist_cont"><div class="content"><ul></ul></div></div><div class="tv_channel_right"></div></div><div id="tv_header"></div>',
        );
      }

      tmp = document.querySelector('#tv_channellist_cont UL');

      if (tmp) {
        tmp.classList.remove('tv_channel_category');
      }

      tmp = document.getElementById('tv_channel_filter');
      filtersNames = channelCategories.getNamesFiltersList();
      if (filtersNames.length) {
        tmp.innerHTML =
          '<span>' +
          getlang('tv_category') +
          ': ' +
          $.each(filtersNames, function (item) {
            return item;
          }) +
          '</span>';
        tmp.style.display = 'block';
      } else {
        tmp.style.display = 'none';
      }

      tmp = '';

      for (const num in channels) {
        // проверка tv_rights
        if (!filterRightsContent(channels[num], 'video')) {
          if (typeof tv_cur_channel === 'undefined') {
            tv_cur_channel = num | 0;
          }

          filtered = true;
          channelCategories(channels[num], tv_channel_categories);

          if (filtersNames.length && filtersNames.indexOf(channels[num].category) === -1) {
            filtered = false;
          }
          if (typeof tv_channel_filter.language !== 'undefined' && tv_channel_filter.language !== channels[num].lang) {
            filtered = false;
          }

          // проверка nopost
          action = handlerNopost(channels, num, 'tv_channel_show(' + num + ');');
          if (filtered === true) {
            tmp +=
              '' +
              '<li data-num="' +
              num +
              '" onvclick="' +
              action +
              '">' +
              '<div class="tv_channel_name">' +
              channels[num].name +
              '</div>' +
              '<div ' +
              'class="tv_channel_logo" ' +
              'style="background:url(' +
              channels[num].image +
              ') 50% no-repeat;"' +
              '></div>' +
              '</li>';
          }
        }
      }
      document.getElementById('tv_channellist_cont').innerHTML = '<div class="content"><ul>' + tmp + '</ul></div>';

      //Смещение
      tmp = $('#tv_channellist').find('LI').outerWidth(true);

      document.querySelector('#tv_channellist .content').style.width = channels.length * tmp + 'px';

      if (fullscreen && !tv_channellist_hidden) {
        tv_sel_block('tv_channellist');
      }

      sendChannelsToMobile();
    }
  }

  function tv_channel_category_build() {
    var categories = channelCategories.getNamesFiltersList(true);

    if (categories.length === 0) {
      return false;
    }

    $('#tv_channel_filter').hide();
    $('#tv_channellist UL').empty();

    var tmp =
      '<li data-num="null" onvclick="tv_channel_filter.category = [];tv_channellist_build();"><span>' +
      getlang('tv_allchannels') +
      '</span></li>';
    for (const num in categories) {
      var hasFilter = channelCategories.hasFilter(num);
      tmp +=
        '' +
        '<li ' +
        'data-num="' +
        num +
        '" ' +
        'onvclick="' +
        (hasFilter ? 'channelCategories.removeFilter(' + num + ')' : 'channelCategories.addFilter(' + num + ')') +
        ';tv_channellist_build();"' +
        (hasFilter ? ' class="tv_sel selected"' : '') +
        '>' +
        '<span>' +
        categories[num] +
        '</span>' +
        '</li>';
    }

    $('#tv_channellist UL').addClass('tv_channel_category').append(tmp);

    tv_sel_block('tv_channellist');
    tv_channellist_fade(true);
  }

  function tv_channellist_show(full) {
    if (full && isset('config.tv_channellist_type') !== 'vertical_new') {
      document.getElementById('tv_fullscreen_overlay').style.display = 'block';
      //document.getElementById('tv_fullscreen_overlay').style.visibility = 'visible';
    }

    if (isset('config.tv_channellist_type') === 'mosaic') {
      return tv_mosaic.server_channel_information.toggle();
    }

    document.getElementById('tv_channellist').style.display = 'block';

    if (tv_sel_list.length === 0) {
      tv_sel_block('tv_channellist');
    }

    if (typeof tv_cur_channel !== 'undefined') {
      var tmp = $('#tv_channellist_cont [data-num]').filter(function () {
        return $(this).data('num') == tv_cur_channel;
      });

      if (tmp.length) {
        tv_cur_pos = tmp.index();
      }
      tv_sel_cur();
    }

    tv_channellist_hidden = false;
    tv_channellist_fade(true);
  }

  function tv_channellist_hide(full) {
    if (full) {
      document.getElementById('tv_fullscreen_overlay').style.display = 'none';
      //		document.getElementById('tv_fullscreen_overlay').style.visibility = 'hidden';
    }

    $('#tv_channellist').hide();
    tv_channellist_hidden = true;

    if (isset('config.tv_channellist_type') === 'vertical_new') {
      $('#tv_cur').hide();
    }
  }

  function tv_channellist_fade(reset) {
    if (typeof fullscreen === 'undefined') {
      return false;
    }

    if (tv_fade_timer) {
      clearTimeout(tv_fade_timer);
      $('#tv_channellist').stop().animate({opacity: 1}, 100);
    }
    if (!reset) {
      tv_fade_timer = setTimeout(function () {
        $('#tv_channellist').animate({opacity: 0}, 500, function () {
          tv_channellist_hidden = true;
          this.style.display = 'none';
        });
        //			document.getElementById('tv_fullscreen_overlay').style.visibility = 'hidden';
        document.getElementById('tv_fullscreen_overlay').style.display = 'none';

        if (isset('config.tv_channellist_type') === 'vertical_new') {
          $('#tv_cur').hide();
        }
      }, 5000);
    }
  }

  function tv_channel_show(tune, coords) {
    var channel,
      id,
      channels = getChannels();

    if (typeof tune === 'object') {
      channel = tune;
      id = -1;
    } else {
      id = tune | 0;
      channel = channels[id];
    }

    if (channel) {
      sendChannelId(channel.id);
    }

    if (isset('config.tv_channellist_type') !== 'mosaic') {
      if (fullscreen && (!channel || tv_cur_channel === id) && id !== -1) {
        tv_channellist_hide(true);
        return false;
      }
    }

    tv_cur_channel_audio = null;
    tv_cur_channel = id;

    _tv_channel_show(channel, coords);

    if (isset('config.tv_channellist_type') !== 'mosaic') {
      tv_channellist_fade();
    }
  }

  window.tv_channellist_hidden = false;
  window.tv_channels = [];
  window.tv_channel_categories = [];
  window.tv_channel_filter = {};
  window.tv_cur_channel = undefined;
  window.tv_prev_cur_channel = undefined;
  window.tv_cur_channel_audio = undefined;

  window.tv_channellist_build = tv_channellist_build;
  window.tv_channel_category_build = tv_channel_category_build;
  window.tv_channellist_show = tv_channellist_show;
  window.tv_channellist_hide = tv_channellist_hide;
  window.tv_channellist_fade = tv_channellist_fade;
  window.tv_channel_show = tv_channel_show;
})();

(function () {
  //todo refactor to logger service
  function tv_log(msg) {
    if (isset('config.tv.suppress_log')) {
      log.add('TV LOG: ' + msg);
    } else {
      if (!document.getElementById('tv_log')) {
        $(document.body).append('<div id="tv_log"></div>');
      }
      var tmp = 'log_' + Math.random();
      $('<div id="' + tmp + '">' + msg + '</div>')
        .appendTo(document.getElementById('tv_log'))
        .delay(10000)
        .fadeOut(0, function () {
          $(this).remove();
        });
    }
  }

  window.tv_log = tv_log;
})();

(function () {
  //TODO: определить место списка остальных гостей
  window.GuestList = null;

  //TODO: контролировать изменение прав
  //TODO: хранить все параметры в объекте. (группы, права, фамилия)
  window.Guest = {
    _token: false,
    guestSurname: '',
    guestName: '',
    guestTitle: '',
    pmsLanguage: '',

    _pmsNum: null,
    get pmsNum() {
      return this._pmsNum;
    },
    set pmsNum(v) {
      this._pmsNum = v;
      $(HotezaTV).trigger('pmsNumUpdated');
    },

    profileNum: null,
    rightsContent: {},
    set_guest: function (r) {
      if (typeof r.token !== 'string') {
        log.add('TV: token error');
        return false;
      }

      if (storage.getItem('token') !== r.token) {
        //First time got this token
        log.add('TV: new guest');

        if (r.lang && r.lang !== get_language()) {
          change_language(r.lang);
        }
      }

      if (storage.getItem('guestData_token') !== r.token) {
        //Очистка, не совпадающий гость
        guestData_clear();

        storage.setItem('guestData_token', r.token);
      }

      if (typeof _tv_checkin == 'function') {
        setTimeout(function () {
          _tv_checkin();
        }, 2000);
      }

      Guest.guestSurname = r.guestName || '';
      Guest.guestName = r.guestFirstName || '';
      Guest.guestTitle = r.guestTitle || '';
      Guest.pmsNum = r.pmsNum || null;
      Guest.profileNum = r.profileNum || null;
      Guest.rightsContent = r.rights || {};
      Guest.additional = r.additional || null;

      // The essence of this entry is in solving the task:
      // https://www.wrike.com/open.htm?id=1334908891
      // Example: French language comes from PMS, but there is no content in the system in this language
      // However, there are channels in French.
      // This field is used to sort channels so that French ones come first.
      Guest.pmsLanguage = r.lang;

      /**
       * video
       *   0    без ограничений
       *   1    Без платных услуг
       *   2    Без ХХХ услуг
       *   3    Все отключено
       * nopost
       *   0    с платным контентом
       *   1    без платного контента
       */
      guestData.groups = r.groups;

      var tvAuthHook = isset('config.tv_auth_function');

      if (typeof tvAuthHook === 'function') {
        try {
          tvAuthHook();
        } catch (e) {
          log.add('TV: override failed');
          tv_set_guest();
        }
      } else {
        tv_set_guest();
      }
      log.add('TV: got token - ' + r.token);

      //Обработчик кастомных полей PMS
      if (typeof tv_pms_function === 'function') {
        try {
          tv_pms_function(r.additional);
        } catch (e) {
          log.add('TV: Error: PMS custom field function failed');
        }
      }

      //Перестроение списка каналов и VOD с учётом доступных групп
      wakeup_status(true);
      filter_content_by_group();
      // tv_sel_block();

      //TODO: контролировать изменение прав
      if (Guest.token != r.token) {
        Guest.token = r.token;
        tv_open_app.open(true);
      } else {
        if (r.lang && r.lang !== get_language()) {
          return change_language(r.lang);
        }
        console.log('reauth');
      }

      //Получение команд от сервера
      tv_get_server_commands();
      Feedback.init();

      // по логике описанной Антоном, в Events приходит сообщение о том,
      // что что-то произошло с тем или иным сервисом,
      // после event'a мы должны сходить на сервер и узнать что же именно произошло
      Events.registerListener('feedback', Feedback.init);

      if (r.guestList && r.guestList.length) {
        GuestList = r.guestList;
      } else {
        GuestList = null;
      }
    },
    clear_guest: function () {
      Guest.token = false;
      Guest.guestSurname = '';
      Guest.guestName = '';
      Guest.guestTitle = '';
      Guest.pmsLanguage = '';
      Guest.pmsNum = null;
      Guest.profileNum = null;
      Guest.rightsContent = {};
    },
  };

  Object.defineProperty(window.Guest, 'token', {
    get: function () {
      return Guest._token;
    },
    set: function (value) {
      var token = storage.getItem('token');
      var isPreviousTokenExists = false;

      if (value === false || value == null || typeof value == 'undefined') {
        isPreviousTokenExists = token;

        storage.removeItem('token');
        console.log('token reset');
        $(HotezaTV).trigger('token:reset');
      } else {
        if (token !== value) {
          $(HotezaTV).trigger('token:new');
        }

        storage.setItem('token', value);
        console.log('token set');

        $(HotezaTV).trigger('token:set');
      }

      Guest._token = value;
      $(HotezaTV).trigger('auth');

      if (isPreviousTokenExists) {
        log.add('AUTH: guest token is cleared');
        $(HotezaTV).trigger('token:remove');
      }
    },
  });
})();

(function () {
  function get_media_subtitles(subtitles) {
    var d = $.Deferred();

    if (typeof subtitles === 'undefined' || !Object.keys(subtitles).length) {
      return d.resolve(null);
    }

    d.resolve(subtitles);

    return d.promise();
  }

  window.get_media_subtitles = get_media_subtitles;
})();

(function () {
  function tv_auth() {
    if (!tv_mac || !tv_sign) {
      //МАК и ключ не получен
      log.add('TV: nomac, nosign');
      return false;
    } else {
      var data = {
        hotelId: get_hotelId(),
        mac: tv_mac,
        manufacturer: tv_manufacturer,
        sign: tv_sign,
      };

      $.post(
        tv_api_url + 'token',
        data,
        function (r) {
          $('#tv_fullscreen_welcome').hide();
          switch (r.result) {
            case 0:
              Guest.set_guest(r);
              HotezaTV.auth = 'OK';
              break;
            case 1:
              HotezaTV.auth = 'invalid sign';
              break;
            case 2:
              HotezaTV.auth = 'hotel not found';
              break;
            case 3:
              HotezaTV.auth = 'MAC not registered';
              break;
            case 4:
              // - если было заселение => сбрасываем до дефолтного языка
              // - если не было, то не сбрасываем.
              // необходимо для переключения языков в НЕ заселенном номере
              if (storage.getItem('token')) {
                setTimeout(setDefaultLanguage, 500);
              }

              guestData_clear();
              tv_set_guest();
              HotezaTV.auth = 'OK';
              break;
            case 5:
              HotezaTV.auth = 'Ой ваще всё плоха, ' + r.message;
              break;
            case 9:
              HotezaTV.auth = 'unknown error (9) ' + r.message;
              break;
            default:
              HotezaTV.auth = 'unknown answer (' + r.result + ') ' + r.message;
              break;
          }
          log.add('TV: ' + HotezaTV.auth);
        },
        'json',
      ).fail(function (err) {
        guestData.groups = [];
        filter_content_by_group();
        HotezaTV.auth = 'error ' + err.status + '|' + err.statusText;
        log.add('TV: ' + HotezaTV.auth);
      });
    }
  }

  function check_auth() {
    var token = Guest.token;
    if (token) {
      return token;
    } else {
      return false;
    }
  }

  function require_auth() {
    var token = check_auth();
    if (token) {
      return token;
    } else {
      //Добавить сообщение
      return false;
    }
  }

  window.tv_auth = tv_auth;
  window.check_auth = check_auth;
  window.require_auth = require_auth;
})();

(function () {
  /**
   * Функция циклического переключения звуковой дорожки (только в classic channels)
   */
  function tv_change_audio() {
    if (typeof _tv_change_audio == 'function') {
      return _tv_change_audio();
    } else {
      log.add('APP: _tv_change_audio not implemented yet');
      console.log('APP: _tv_change_audio not implemented yet');
      return $.Deferred().reject('APP: _tv_change_audio not implemented yet');
    }
  }

  function tv_cur_audio_display(audio) {
    //{int index, array list} {0, ['ru','en']}
    //	audio['list'][audio['index']] = audio['list'][audio['index']].toUpperCase();
    //	tv_log(audio['list'].join(' '));
    if (!$('#tv_channel_number').length) {
      $(document.body).append($('<div id="tv_channel_number"></div>'));
    }
    $('#tv_channel_number').html(audio.list[audio.index].toUpperCase());

    setTimeout(function () {
      $('#tv_channel_number').remove();
    }, 5000);
  }

  window.tv_change_audio = tv_change_audio;
  window.tv_cur_audio_display = tv_cur_audio_display;
})();

(function () {
  function tv_get_server_commands() {
    var data = {
      token: Guest.token,
      cmd: 'alarm',
      tvIndex: Events.TVID(),
    };

    $.post(config.admin_url + 'jsonapi/getTask', data, function (r) {
      switch (r.result) {
        case 0:
          if (r.payload.length === 0) {
            log.add('TV: cmd: no commands');
          }

          for (const i in r.payload) {
            var cmd = r.payload[i];
            switch (cmd.cmd) {
              case 'alarm':
                //Фильтрация будильника по зонам
                if (cmd.data[3] && cmd.data[3] != Events.TVID()) {
                  log.add('WAKEUP: got wakeup for another TVID');
                  return false;
                }

                wakeup_status(false);

                var alarm_dif = Math.round(time.now(true) / 1000) - cmd.data[1];
                if (alarm_dif < 10 * 60) {
                  switch (cmd.data[2]) {
                    case 'tv_channel':
                      if (system_started) {
                        setTimeout(tv_wakeup, 1000);
                      } else {
                        $(HotezaTV).one('final', function () {
                          setTimeout(tv_wakeup, 1000);
                        });
                      }
                      break;
                    default:
                      log.add('WAKEUP: unknown type ' + cmd.data[2]);
                      break;
                  }
                } else {
                  log.add('WAKEUP: overdue ' + toHHMMSS(alarm_dif));
                }
                break;

              case 'welcome':
                // Вся логика перенесена в tv_open_app.open()
                break;

              case 'fire_alarm':
                fire_alarm();
                break;

              default:
                log.add('TV: cmd: not yet implemented "' + cmd[0] + '"');
                break;
            }
          }
          break;

        default:
          log.add('TV: cmd: Error or Unknown answer - ' + r.result + ' Message: ' + r.message);
          break;
      }
    }).fail(function (xhr, error) {
      log.add('TV: cmd: error');
    });
  }

  window.tv_get_server_commands = tv_get_server_commands;
})();

(function () {
  var tv_wakeup_cnt;

  function tv_wakeup() {
    if (tv_cur_block === 'tv_welcome') {
      tv_welcome_hide();
    }

    if ('Wakeupcall' in window) {
      // Добавлена задержка, так как на EC690
      // видео на будильнике не запускалось
      return setTimeout(Wakeupcall.open.bind(null, 'wakeup'), 1000);
    } else if ('Wakeupcall2' in window) {
      return setTimeout(Wakeupcall2.onAlarm, 1000);
    }

    if (!fullscreen) {
      tv_mode();
    }

    tv_wakeup_volume(isset('config.tv.wakeup.start_volume') | 0);

    $(document).one('keydown', function () {
      tv_wakeup_volume_cancel();
      custom_dialog_close();
      tv_task_answer({answer: 'tvwolok'});
      tv_mode();
    });

    setTimeout(function () {
      var cur_channel = isset('config.tv.wakeup.channel');
      _tv_channel_show(cur_channel);
      tv_cur_channel = cur_channel;

      custom_dialog('alert', getlang('wakeup_title'), getlang('wakeup_message'));
      custom_dialog_resize(400);
      tv_sel_cur();

      $('#tv_cur').css('visibility', 'visible');
    }, 3000);

    tv_task_answer({answer: 'tvwolon'});
  }

  function tv_wakeup_volume(i) {
    tv_set_volume(i);
    if ((i < isset('config.tv.wakeup.end_volume')) | 0) {
      tv_wakeup_cnt = setTimeout(function () {
        tv_wakeup_volume(i + 1);
      }, 3 * 1000);
    } else {
      tv_wakeup_volume_cancel();
    }
  }

  function tv_wakeup_volume_cancel() {
    clearTimeout(tv_wakeup_cnt);
  }

  window.tv_wakeup = tv_wakeup;
  window.tv_wakeup_volume = tv_wakeup_volume;
  window.tv_wakeup_volume_cancel = tv_wakeup_volume_cancel;
})();

(function () {
  function tv_task_answer(data) {
    data.token = storage.getItem('token');
    $.post(api_url + 'taskAnswer', data, function (r) {
      switch (r.result) {
      }
    });
  }

  window.tv_task_answer = tv_task_answer;
})();

(function () {
  $(HotezaTV).one('splashout', function () {
    getServerCommandsAsync({
      payload: {
        token: Guest.token,
        cmd: 'fire_alarm',
      },
    }).done(function (result) {
      for (const i in result) {
        var cmd = result[i];
        switch (cmd.cmd) {
          case 'fire_alarm':
            fire_alarm();
            break;
        }
      }
    });
  });

  function fire_alarm() {
    tv_welcome_hide();
    _tv_set_volume(30);
    $('#container').html(
      '<div style="z-index: 1000000000000000000;width:100%;height:100%;background-image:url(i/fire.gif); background-position: center; background-repeat: no-repeat; background-color: #000;"></div>' +
        '<audio src="tv/sound/fire.mp3" autoplay loop></audio>'
    );
    $('#tv_cur').hide();
    $('#tv_fullscreen_overlay').hide();

    setCurrentTvKeydownOverride(() => {});

    active_page = '#fire_alarm';
  }

  window.fire_alarm = fire_alarm;
})();

(function () {
  var _standbyState = 'unknown';
  Object.defineProperty(window, 'tv_virtual_standby_state', {
    get() {
      return _standbyState;
    },
    set(v) {
      $(HotezaTV).trigger('tv_virtual_standby_state', v);
      _standbyState = v;
    }
  });

  function tv_virtual_standby_off() {
    if (tv_virtual_standby_state == false) {
      hash.set('standby');
      tv_virtual_standby_state = true; //смысл в этом небольшой - прилага идёт на перезагрузку, но пусть будет
      log.persistent.add('power off', 'RELOAD');
      log.add('TV: reload, TV off');
      reload_app();
    } else {
      log.add('Virtual Standby: already OFF');
    }
  }

  function tv_virtual_standby_on() {
    if (tv_virtual_standby_state == true) {
      log.add('Virtual Standby: TV turned ON (' + time.uptime(true) + ')');
      HotezaTV.metrics.was_standby = time.uptime();

      hash.set('standby', null);
      tv_virtual_standby_state = false;
      if (isset('config.tv.hacks.reload_on_poweron')) {
        log.persistent.add('power on (hack)', 'RELOAD');
        reload_app();
      } else {
        log.persistent.add('proceed', 'SYSTEM');
        tv_ready();
      }
    } else {
      log.add('Virtual Standby: already ON');
    }
  }

  window.tv_virtual_standby_off = tv_virtual_standby_off;
  window.tv_virtual_standby_on = tv_virtual_standby_on;
})();

(function () {
  function tv_get_elements_in_direction(elements, coords, dir) {
    var array = [],
      c;
    elements.each(function (index) {
      var data = $.data(this);
      // TODO: Consider using epsilon (tolerance) for coordinate comparisons to handle sub-pixel precision issues.
      // for example, instead of checking if (data.left + data.width > coords.x), use if (data.left + data.width > coords.x + epsilon)
      // NOTE: For reliable navigation between elements, ensure there are at least a few pixels of spacing between them, rather than placing them directly adjacent.
      switch (dir) {
        case 'right':
          if (data.left < coords.x) {
            return true;
          }
          c = {
            x: data.left,
            y: data.top + data.height / 2,
          };
          break;
        case 'left':
          if (data.left + data.width > coords.x) {
            return true;
          }
          c = {
            x: data.left + data.width,
            y: data.top + data.height / 2,
          };
          break;
        case 'up':
          if (data.top + data.height > coords.y) {
            return true;
          }
          c = {
            x: data.left + data.width / 2,
            y: data.top + data.height,
          };
          break;
        case 'down':
          if (data.top < coords.y) {
            return true;
          }
          c = {
            x: data.left + data.width / 2,
            y: data.top,
          };
          break;
        default:
          console.log('Unknown direction');
          break;
      }

      array.push({
        id: index,
        l: Math.sqrt(Math.pow(c.x - coords.x, 2) + Math.pow(c.y - coords.y, 2)),
      });
    });

    return array;
  }

  /**
   * Gets the index of the nearest element in a specified direction
   * @param {jQuery} elements - Collection of elements to search through
   * @param {Object} element - Current element's position data
   * @param {string} dir - Direction to search ('up', 'down', 'left', 'right')
   * @returns {number | false} Index of the nearest element or false if no element found
   */
  function tv_get_nearest_element(elements, element, dir) {
    var x, y;
    switch (dir) {
      case 'right':
        x = element.left + element.width;
        y = element.top + element.height / 2;
        break;
      case 'left':
        x = element.left;
        y = element.top + element.height / 2;
        break;
      case 'up':
        x = element.left + element.width / 2;
        y = element.top;
        break;
      case 'down':
        x = element.left + element.width / 2;
        y = element.top + element.height;
        break;
      default:
        break;
    }

    var array = tv_get_elements_in_direction(
      elements,
      {
        x: x,
        y: y,
      },
      dir,
    );

    if (array.length === 0) {
      return false;
    }

    // Sort
    var index = tv_cur_pos,
      val = 0;

    var tmp_i = array.length;
    for (let i = 0; i < tmp_i; i++) {
      var tmp = array[i];
      if (i === 0) {
        index = tmp.id;
        val = tmp.l;
      } else {
        if (tmp.l < val) {
          index = tmp.id;
          val = tmp.l;
        }
      }
    }

    return index;
  }

  function metro_menu_calc($elements, flag) {
    if (!$elements) {
      $elements = tv_sel_list;
    }

    var element = $elements.get(0);
    // TODO: Needs improvements
    if (!flag && $elements.length > 0 && $.data(element, 'top') == element.getBoundingClientRect().top) {
      // TODO: Why returns true? Find out the usage and remove it
      return true;
    }

    $elements.each(function () {
      $.data(this, this.getBoundingClientRect());
    });
  }

  function metro_menu_move(dir) {
    var index = tv_get_nearest_element(tv_sel_list, $.data(tv_cur_elem.get(0)), dir);

    if (index === false) {
      return false;
    }

    previousPosition.set(tv_cur_pos);

    tv_cur_pos = index;
    tv_sel_cur();

    metro_menu_calc();

    return index;
  }

  // TODO: Refactor navigation logic to use the Strategy pattern.
  // The current implementation tightly couples the navigation logic with specific containers like ScrollContainer.
  // This violates the Open/Closed Principle and makes the code less flexible and harder to test.
  // We can abstract the navigation behavior into a strategy interface
  // with concrete implementations for different behaviors (e.g., DefaultNavigationStrategy, ScrollContainerStrategy).
  // Maybe the context (handleSelectableNavigation) should delegate the navigation task to the appropriate strategy
  // based on the element's configuration
  function handleSelectableNavigation(direction) {
    var nextIndex = false;

    var isInScrollContainer = ScrollContainer.checkScrollContainer(tv_cur_elem);
    if (isInScrollContainer) {
      nextIndex = ScrollContainer.handleNavigation(direction, tv_cur_pos, tv_cur_elem, tv_sel_list);

      if (nextIndex === ScrollContainer.NO_MOVEMENT) {
        nextIndex = tv_get_nearest_element(tv_sel_list, $.data(tv_cur_elem.get(0)), direction);
      } else if (nextIndex === ScrollContainer.EDGE_LIMIT) {
        // TODO: Move data-nav fields to ScrollContainer class when refactoring navigation logic
        // Enable navigation out of scroll container if allowed
        var $scrollContainer = tv_cur_elem.parents('.scroll-container').first();
        if (
          $scrollContainer.length && (
            $scrollContainer.attr('data-nav-out') === 'all' ||
            $scrollContainer.attr('data-nav-out') === direction
          )
        ) {
          nextIndex = tv_get_nearest_element(tv_sel_list, $.data(tv_cur_elem.get(0)), direction);
        } else {
          return false;
        }
      }
    }
    else {
      nextIndex = tv_get_nearest_element(tv_sel_list, $.data(tv_cur_elem.get(0)), direction);
      var $nextElement = tv_sel_list.eq(nextIndex);
      var willBeInScrollContainer = ScrollContainer.checkScrollContainer($nextElement);

      if (willBeInScrollContainer) {
        ScrollContainer.handleScrollContainer(nextIndex, tv_sel_list);
      }
    }

    if (nextIndex === false) {
      return false;
    }

    previousPosition.set(tv_cur_pos);
    tv_cur_pos = nextIndex;
    tv_sel_cur();

    metro_menu_calc(null, isInScrollContainer);

    return true;
  }

  window.metro_menu_calc = metro_menu_calc;
  window.metro_menu_move = metro_menu_move;
  window.handleSelectableNavigation = handleSelectableNavigation;
})();

(function () {
  //NOT USED!
  /*
  function tv_get_elements_in_coords(elements, coords){ //{x1: 0, x2: 0, y1: 0, y2:0}

    var out = elements.filter(function(){
      //console.log($(this).offset().left);
      return ($(this).offset().left >= coords.x1 && $(this).offset().top >= coords.y1 && $(this).offset().left <= coords.x2 && $(this).offset().top <= coords.y2);
    });
    var array = [];
    out.each(function(){
      array.push({x: $(this).offset().left, y:$(this).offset().top, id: $(this).index()});
    });

    return array;
  }
  */
})();

(function () {
  function tv_sources_page(show_all) {
    //deleted
    console.log('tv sources old call');

    if (!isset('config.tv.hacks.useMenuTitleForSourcesPage')) {
      return false;
    }

    var title = null;
    for (let i = 0; i < Object.values(structv2.menu).length; i++) {
      var menuItem = Object.values(structv2.menu)[i];
      if (menuItem.link === '#sources_page') {
        title = menuItem.title;
        break;
      }
    }

    $('#sources_page .header h1').text(title);

    return false;
  }

  function tv_source(params) {
    if (typeof _tv_source == 'function') {
      if (!_tv_source(params)) {
        custom_alert('Source not connected');
        return false;
      } else {
        return true;
      }
    } else {
      console.log('SOURCE CHANGE NOT SUPPORTED');
      return false;
    }
  }

  window.tv_sources_page = tv_sources_page;
  window.tv_source = tv_source;

  window.Sources = {
    _sources: {
      input_list: {
        icon: 'sources-icon-settings_input_hdmi',
        open: function () {
          _tv_sources();
        },
      }, //param: [input, input]
      app_list: {
        icon: 'sources-icon-airplay',
        open: function (appName) {
          Apps.open(appName);
        },
      },
      /**
       * @params string - param = hdmi[1~5]
       * */
      input: {
        icon: 'sources-icon-settings_input_hdmi',
        open: function (param) {
          if (!param) {
            log.add('SOURCES: empty input');
            return false;
          }
          var tmp = param.match(/hdmi(\d)/i);
          if (tmp) {
            //TODO: заменить на tv_source после переделки вендорных на промисы
            _tv_source(['HDMI', tmp[1] - 1]);
            return true;
          } else {
            log.add('SOURCES: cannot parse input');
            return false;
          }
        },
      }, //param: input
      miracast: {
        icon: 'sources-icon-androidwindows',
        open: function () {
          Apps.miracast();
        },
      },
      hotezastream_appletv: {
        icon: 'sources-icon-airplay',
        open: function () {
          AirStream.start();
        },
      },
      hotezastream_chromecast: {
        icon: 'sources-icon-cast',
        open: function () {
          AirStream.start(true);
        },
      },
      usb: {
        icon: 'sources-icon-usb',
        open: function () {
          _tv_usb();
        },
      },
      bluetooth: {
        icon: 'sources-icon-settings_bluetooth',
        open: function () {
          tv_bt.open();
        },
      },
      chromecast: {
        icon: 'sources-icon-cast',
        open: function (param) {
          Chromecast.open(param);
        },
      },
      built_in_google_cast: {
        icon: 'sources-icon-cast',
        open: function () {
          GoogleCastBuiltIn.open();
        },
      },
      built_in_apple_airplay: {
        icon: 'sources-icon-airplay',
        open: function () {
          AirPlayBuiltIn.open();
        },
      },
    },
    init: function () {
      if (isset('structv2.config.sources')) {
        UI.register_page({id: 'sources_page', action: {func: Sources.open, param: false}});
        //UI.register_page({id: 'sources_page_all', action: {func: Sources.open, param: true}});
      } else {
        UI.register_page({id: 'sources_page', action: {func: Sources.open_old, param: false}});
      }
    },
    open: function (show_all) {
      if (fullscreen === true) {
        tv_mode();
      }
      if (tv_cur_block === 'tv_welcome') {
        tv_welcome_hide();
      }

      var tmp;
      if (show_all) {
        tmp = [];
        var keys = Object.keys(Sources._sources);
        for (let k = 0; k < keys.length; k++) {
          tmp.push({
            type: keys[k],
            title: keys[k],
            description: keys[k],
          });
        }
      } else {
        tmp = isset('structv2.config.sources');
      }
      var items = [];
      for (const i in tmp) {
        if (Object.keys(Sources._sources).indexOf(tmp[i].type) == -1) {
          log.add('SOURCES: unknown source in struct: ' + tmp[i].type);
          continue;
        }
        //Исключения при построении на STB
        if (tv_manufacturer == 'mag' || tv_manufacturer == 'tvip') {
          //TODO: supported sources from vendor (get_supported_sources)
          if (['input_list', 'input', 'miracast', 'usb', 'bluetooth'].indexOf(tmp[i].type) != -1) {
            log.add('SOURCES: source ' + tmp[i].type + ' unavailable on STB');
            continue;
          }
        }
        if (tmp[i].icon && tmp[i].icon !== '') {
          if (isset('structv2.config.icon_library')) {
            // Using svg icon
            tmp[i].svg_icon = true;
            tmp[i].iconVal = SVG.getIconSvg(tmp[i].icon);
          } else {
            tmp[i].svg_icon = false;
          }
        } else {
          tmp[i].svg_icon = false;
        }

        Object.assign(tmp[i], Sources._sources[tmp[i].type]);
        tmp[i].id = 'sources_' + tmp[i].type;
        items.push(tmp[i]);
      }

      if (!$id('sources_page')) {
        var sources_page_object = {
          title: getlang('tv_sources_page'),
          items: items,
        };
        if (HotezaTV.history.lastpage == '#menu' || HotezaTV.history.lastpage == '#sources_page') {
          sources_page_object.backBtn = 0;
          sources_page_object.parentId = '';
        } else {
          sources_page_object.backBtn = 1;
          sources_page_object.parentId = active_page_id || 'menu';
        }
        renderPageOnTheStructv2('sources_page', sources_page_object, 'sources_page');
        filter_content_by_group();
        navigate('#sources_page');
      }
    },
    open_old: function (show_all) {
      if (fullscreen === true) {
        tv_mode();
      }
      if (tv_cur_block === 'tv_welcome') {
        tv_welcome_hide();
      }

      var tmp = [];
      //построение. один раз. кнопка "назад" зависит от страницы с которой вызывается функция первый раз
      if (!$id('sources_page')) {
        var sources = {
          SOURCES: {
            id: 1,
            title: getlang('tv_sources'),
            icon: 'sources-icon-settings_input_hdmi',
            onvclick: '_tv_sources(' + show_all + ');',
          },
          HDMI: {
            id: 2,
            title: 'HDMI',
            icon: 'sources-icon-settings_input_hdmi',
            onvclick: '_tv_sources(' + show_all + ');',
          },
          MIRACAST: {
            id: 3,
            title: getlang('screen_sharing'),
            icon: 'sources-icon-androidwindows',
            onvclick: 'Apps.miracast();',
          },
          APPLETV: {
            id: 4,
            title: 'Apple TV',
            icon: 'sources-icon-airplay',
            onvclick: "_tv_source(['HDMI', 0])",
          },
          CHROMECAST: {
            id: 5,
            title: 'ChromeCast',
            icon: 'sources-icon-cast',
            onvclick: "_tv_source(['HDMI', 1])",
          },
          AIRSTREAM: {id: 6, title: 'Apple TV', icon: 'sources-icon-airplay', onvclick: 'AirStream.start()'},
          CHROMESTREAM: {
            id: 7,
            title: 'ChromeCast',
            icon: 'sources-icon-cast',
            onvclick: 'AirStream.start(true)',
          },
          USB: {id: 8, title: 'USB', icon: 'sources-icon-usb', onvclick: '_tv_usb();'},
          BLUETOOTH: {
            id: 9,
            title: 'Bluetooth',
            icon: 'sources-icon-settings_bluetooth',
            onvclick: 'tv_bt.open()',
          },
        };

        if (show_all) {
          tmp = Object.keys(sources);
        } else {
          tmp = isset('config.tv.external_devices') || ['SOURCES', 'MIRACAST', 'USB'];
        }

        var items = [];
        for (const i in tmp) {
          //Исключения при построении на STB
          if (tv_manufacturer == 'mag' || tv_manufacturer == 'tvip') {
            if (['SOURCES', 'HDMI', 'MIRACAST', 'USB', 'BLUETOOTH'].indexOf(tmp[i]) != -1) {
              continue;
            }
          }
          items.push(sources[tmp[i]]);
        }

        var sources_page_object = {
          title: getlang('tv_sources_page'),
          items: items,
        };
        if (tv_cur_block == 'menu') {
          sources_page_object.backBtn = 0;
          sources_page_object.parentId = '';
        } else {
          sources_page_object.backBtn = 1;
          sources_page_object.parentId = active_page_id;
        }
        renderPageOnTheStructv2('sources_page', sources_page_object, 'sources_page_old');
        navigate('#sources_page');
      }
    },
    open_source: function (type, param) {
      Media.stop({directType: null, shutdown: true});

      if (Sources._sources[type]) {
        try {
          Sources._sources[type].open(param);
        } catch (e) {
          log.add('SOURCES: open failed, exception: ' + e);
          console.log(e);
        }
      } else {
        log.add('SOURCES: open failed, unknown source type "' + type + '"');
      }
    },
    register: function (key, descriptor) {
      this._sources[key] = descriptor;
    },
  };

  $(HotezaTV).on('splashshow', window.Sources.init);
})();

(function () {
  function wakeup_status(visible, when, orderId) {
    var container = document.getElementById('tv_fullscreen_alarm');

    if (typeof when !== 'undefined') {
      wakeup_status.set(when, orderId);
    }

    when = wakeup_status.get('time');

    if (!isset('config.tv.wakeup_status_exist')) {
      return false;
    }

    var isValidWakeup = wakeup_status.isValidWakeup();
    if (visible && isValidWakeup) {
      if (!when) {
        return false;
      }

      container.querySelector('#wakeup_time').innerHTML = when;
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
      wakeup_status.set('');
    }
  }

  wakeup_status.get = function (type, isFullTime) {
    var data = load_data(),
      result = getData(data, type);

    if (!result) {
      return null;
    }

    if ((result && type === 'orderId') || (isFullTime && type === 'time')) {
      return result;
    }

    return getTime(result);

    function getTime(date) {
      return date.split(' ')[1].substring(0, 5);
    }

    function getData(_data, _type) {
      if (typeof _data.wakeup === 'undefined' || typeof _data.wakeup[_type] === 'undefined') {
        return null;
      }

      return _data.wakeup[_type];
    }
  };
  wakeup_status.set = function (t, orderId) {
    var data = load_data();

    data.wakeup = {
      time: t,
      orderId: orderId,
    };

    save_data(data);
  };
  wakeup_status.isValidWakeup = function () {
    var date = wakeup_status.get('time', true);
    if (!date) {
      return true;
    }
    const wakeupMoment = moment.tz(date, 'YYYY-MM-DD HH:mm:ss', window.timeService.timezone);
    return wakeupMoment.isValid() && wakeupMoment.isAfter(window.timeService.now);
  };

  window.wakeup_status = wakeup_status;
})();

(function () {
  function tv_get_state() {
    var tmp = {
      version: version.v,
      mac: tv_mac,
      active_page_id: isset('active_page_id', 'none'),
      tv_cur_block: isset('tv_cur_block', 'none'),
      tv_manufacturer: isset('tv_manufacturer', 'none'),
      language: get_language(),
      server: getServerUrl() || '',
      ua: ua || '',
      tv: tv_get_info(),
    };

    if (tv_virtual_standby_state) {
      tmp.status = 'standby';
    }

    if (tv_cur_elem) {
      try {
        tmp.tv_cur_elem = {
          id: tv_cur_elem.attr('id') || '',
          href: tv_cur_elem.attr('href') || '',
          onvclick: tv_cur_elem.attr('onvclick') || '',
          textContent: tv_cur_elem[0].textContent.trim() || '',
        };
      } catch (e) {
        tmp.tv_cur_elem = 'bad';
        log.add('ERROR: tv_cur_elem bad');
      }
    } else {
      tmp.tv_cur_elem = 'none';
    }

    if (tv_last_key) {
      try {
        tmp.tv_last_key = tv_last_key + ' (' + (tv_keys_reverse[tv_last_key] || '_no_key_') + ')';
      } catch (e) {
        tmp.tv_last_key = 'bad';
        log.add('ERROR: tv_last_key bad');
      }
    } else {
      tmp.tv_last_key = 'none';
    }

    try {
      tmp.uptime = time.uptime(true);
    } catch (e) {
      tmp.uptime = 'bad';
      log.add('ERROR: uptime bad');
    }

    return tmp;
  }

  window.tv_get_state = tv_get_state;
})();

(function () {
  window.sleep_timer = {
    power_off: false,
    time_for_sleep: null,
    timer: {
      timeout: null,
      interval: null,
    },
    default_choices: [0, 30, 60, 90, 120, 150, 180],
    detach_keydown: null,
    /**
     * Открыть sleep_timer
     * @param {object} [to] - страница вида $(`#${id}`)
     * @param {string} [backAction] - дополнительные действия при закрытии страницы
     * */
    open: function (to, backAction) {
      this.render(to, backAction);

      // if (tv_keydown_override) {
      // 	this.detach_keydown = tv_keydown_override;
      // }

      // tv_keydown_override = this.tv_keydown;

      // navigate('#sleep_timer', 'popup');
      this.set_current_time();
      this.power_off = false;
    },

    close: function () {
      Popup.hide();
    },

    off: function (only_clear) {
      clearInterval(this.timer.timeout);
      clearInterval(this.timer.interval);

      this.time_for_sleep = null;

      if (only_clear) {
        return;
      }

      this.set_current_time();
      select_item();
      tv_back();
    },
    transform_choices: function (arr) {
      for (var i in arr) {
        if (typeof arr[i] == 'number') {
          if (arr[i] == 0) {
            arr[i] = {
              //TODO: translation ('mins' too)
              item: 'Off',
              itemName: false,
              onvclick: 'sleep_timer.off()'
            };
          } else {
            arr[i] = {
              item: arr[i],
              itemName: true,
              onvclick: 'sleep_timer.set(' + (arr[i] * T_MIN) + ')'
            };
          }
        }
      }
      return arr;
    },
    render: function (to, backAction) {
      to = typeof to !== 'undefined' ? to : null;
      backAction = typeof backAction !== 'undefined' ? 'sleep_timer.close();' + backAction : 'sleep_timer.close()';

      var choices = [];

      if (isset('config.tv.sleep_timer.data')) {
        choices = this.transform_choices(isset('config.tv.sleep_timer.data'));
      } else {
        choices = this.transform_choices(this.default_choices);
      }

      var data = {
        id: 'sleep_timer',
        data: choices,
        lang: {
          title: getlang('sleep_timer'),
          itemName: getlang('minutes_short'),
        },
        backOnvclick: backAction,
        tpl: true,
        tplType: 'popup_list',
        klass: '',
        to: to,
      };

      Popup.show(data);
    },
    get: function () {
      if (this.time_for_sleep === null) {
        return null;
      }

      return Math.floor(this.time_for_sleep / 1000 / 60);
    },
    set: function (millisec, withoutShowed) {
      this.off(true);
      if (!millisec) {
        return true;
      }

      millisec = parseInt(millisec);
      this.timer.timeout = setTimeout(tv_poweroff, millisec);

      this.time_for_sleep = millisec;
      this.timer.interval = setInterval(sleep_timer._update.bind(this), 1000);

      if (withoutShowed) {
        return false;
      }

      this.set_current_time();
      select_item();
      tv_back();
    },
    set_current_time: function () {
      var current_data = $('#sleep_timer').find('.current_data');
      if (this.get()) {
        current_data.html(': ' + getlang('in') + ' ' + this.get() + ' ' + getlang('minutes_short'));
      } else {
        current_data.html('');
      }

      tv_sel_cur();
    },
    _update: function () {
      this.time_for_sleep = this.time_for_sleep - 1000;

      this.attention();

      if (this.time_for_sleep <= 0 && !this.power_off) {
        this.off(true);
        this.set_current_time();

        log.persistent.add('sleep timer', 'POWEROFF');
        tv_poweroff();
        this.power_off = true;
      }
    },

    // tv_keydown: function (e) {
    // 	var code = getKeyCode(e);

    // 	switch (code) {
    // 		case tv_keys.UP:
    // 		case tv_keys.RIGHT:
    // 		case tv_keys.DOWN:
    // 		case tv_keys.LEFT:
    // 		case tv_keys.ENTER:
    // 			tv_keydown(e, true);
    // 			break;
    // 		case tv_keys.BACK:
    // 			tv_back();
    // 			break;
    // 		default:
    // 			tv_back();
    // 			tv_keydown(e);
    // 	}
    // },

    /**
     * Ф-ия запускается за минуту до выключения ТВ
     * и предупреждает пользователя о скором выключении
     * */
    attention: function () {
      if (!this.time_for_sleep || this.time_for_sleep > 60 * 1000) {
        return false;
      }

      var customDialog = document.getElementById('custom_dialog');

      if (customDialog) {
        return updateTime(customDialog, this.time_for_sleep / 1000);
      }

      custom_confirm({
        title: getlang('sleep_timer'),
        text: getlang('sleep_timer_will_powered_of'),

        confirm: getlang('continue_watching_tv'),
        cancel: null,
        onConfirm: sleep_timer.off.bind(this, true),
      });

      function updateTime(dialog, _time) {
        var addedInfo = dialog.querySelector('#custom_dialog_added_info');

        if (addedInfo) {
          addedInfo.innerHTML = _time;
          return;
        }

        dialog
          .querySelector('.button_wrap')
          .insertAdjacentHTML(
            'beforebegin',
            '<tr class="custom_dialog_added_info"><td id="custom_dialog_added_info">' + _time + '</td></tr>',
          );

        custom_dialog_resize();
        tv_sel_cur();
      }
    },
  };
})();

(function () {
  function setVideoSize(coords) {
    if (!coords || typeof coords !== 'object') {
      coords = {
        top: 0,
        left: 0,
        //TODO: изменить и проверить ww и wh
        width: 1280,
        height: 720,
      };
    }
    _setVideoSize(coords);
  }

  window.setVideoSize = setVideoSize;
})();

(function () {
  window.tv_bt = {
    open: function () {
      var tmp_page = {
        id: 'tv_source_bt',
        title: 'Bluetooth',
        back: {
          href: '#sources_page',
          onvclick: '',
        },
        content: getlang('now_you_can_connect') + ' <div id="source_bt_devices"></div>',
      };

      if (!$id('tv_source_bt')) {
        UI.build_page(tmp_page);
        $('#tv_source_bt').prepend('<span class="wrap_img" style="background-image:url(i/bluetooth.png)"></span>');
        $('#tv_source_bt').attr('onclose', 'tv_bt.close()');
      }

      navigate('#tv_source_bt');

      _tv_bt_on();
    },
    close: function () {
      _tv_bt_off();
    },
  };
})();

(function () {
  // function wrap_function(func_name) {
  //   var func = window[func_name];
  //   if (typeof func == 'function') {
  //     return func;
  //   } else {
  //     return function () {
  //       log.add('APP: ' + func_name + ' not implemented yet');
  //       console.log('APP: ' + func_name + ' not implemented yet');
  //     };
  //   }
  // }
  //~ var tv_poweroff = wrap_function('_tv_poweroff');
  //~ var tv_poweron = wrap_function('_tv_poweron');

  function tv_poweroff() {
    if (typeof _tv_poweroff == 'function') {
      return _tv_poweroff();
    } else {
      log.add('APP: _tv_poweroff not implemented yet');
      console.log('APP: _tv_poweroff not implemented yet');
      return $.Deferred().reject('APP: _tv_poweroff not implemented yet');
    }
  }

  function tv_poweron() {
    if (typeof _tv_poweron == 'function') {
      return _tv_poweron();
    } else {
      log.add('APP: _tv_poweron not implemented yet');
      console.log('APP: _tv_poweron not implemented yet');
      return $.Deferred().reject('APP: _tv_poweron not implemented yet');
    }
  }

  function tv_power(state) {
    if (typeof state == 'undefined') {
      return _get_power_state();
    } else if (state === true || state === 'on') {
      return tv_poweron();
    } else if (state === false || state === 'off') {
      return tv_poweroff();
    } else {
      log.add('POWER: unknown state ' + state);
      return $.Deferred().reject('POWER: unknown state ' + state);
    }
  }

  function tv_reboot() {
    if (typeof _tv_reboot == 'function') {
      _tv_reboot();
    } else {
      log.add('APP: tv_reboot not implemented yet');
      console.log('APP: tv_reboot not implemented yet');
    }
  }

  function tv_set_volume(value) {
    //TODO: возможно надо устанавливать не в 100
    //TODO: возможно надо разделить как-то (смешанная инсталляция)
    if (isset('config.tv.hacks.volume_control_disable')) {
      value = 100;
    }
    //TODO: реализация в процентах (приставки и Philips)
    if (typeof _tv_set_volume == 'function') {
      _tv_set_volume(value);
    } else {
      log.add('APP: _tv_set_volume not implemented yet');
      console.log('APP: _tv_set_volume not implemented yet');
      return false;
    }
  }

  function tv_mute(value) {
    var d = $.Deferred();
    if (typeof _tv_mute == 'function' && typeof _tv_get_mute == 'function') {
      _tv_get_mute()
        .done(function (state) {
          if (state != value) {
            var tmp = _tv_mute();
            if (tmp && typeof tmp.done === 'function') {
              tmp
                .done(function () {
                  d.resolve(!state);
                })
                .fail(function () {
                  d.reject('failed to mute/unmute');
                });
            } else {
              //sync
              d.resolve(!state);
            }
          } else {
            //already set
            d.resolve(state);
          }
        })
        .fail(function () {
          d.reject('failed to get mute state');
        });
    } else {
      log.add('APP: tv_mute not implemented yet');
      console.log('APP: tv_mute not implemented yet');
      d.reject('not implemented');
    }
    return d.promise();
  }

  window.tv_poweroff = tv_poweroff;
  window.tv_poweron = tv_poweron;
  window.tv_power = tv_power;
  window.tv_reboot = tv_reboot;
  window.tv_set_volume = tv_set_volume;
  window.tv_mute = tv_mute;
})();

(function () {
  function showLegend(duration) {
    $('#tv_fullscreen_overlay')
      .stop()
      .animate({opacity: 1}, typeof duration !== 'undefined' ? duration : 0);
  }

  function hideLegend(duration) {
    $('#tv_fullscreen_overlay')
      .stop()
      .animate({opacity: 0}, typeof duration !== 'undefined' ? duration : 0);
  }

  window.showLegend = showLegend;
  window.hideLegend = hideLegend;
})();

(function () {
  window.fullscreenVideoPage = {
    timer: null,
    _listener: null,
    open: function () {

      if (!this._listener) {
        this._listener = this._listenerMethod.bind(this);
      }

      $(document).on('keydown', this._listener);
      this.hideLegend();
      _tv_bg_prepare();
    },
    close: function () {

      clearTimeout(fullscreenVideoPage.timer);
      $(document).off('keydown', this._listener);
      this.showLegend(0);
      _tv_bg_restore();
    },
    showLegend: function (duration) {
      showLegend(duration);
      $('.fullscreen_video.active_page .breadcrumbs, .fullscreen_video.active_page .page-navigator')
        .stop()
        .animate({opacity: 1}, duration);

      if (tv_max_pos) {
        showSelectionIndicator();
      }
    },
    hideLegend: function () {
      clearTimeout(fullscreenVideoPage.timer);
      fullscreenVideoPage.timer = setTimeout(function () {
        if (tv_cur_block !== 'fullscreen_video') {
          return false;
        }

        $('.fullscreen_video.active_page .breadcrumbs, .fullscreen_video.active_page .page-navigator')
          .stop()
          .animate({opacity: 0}, 500);
        hideLegend(500);

        if (tv_max_pos) {
          hideSelectionIndicator();
        }
      }, 5000);
    },
    _listenerMethod: function () {
      this.showLegend(500);
      this.hideLegend();
    },
  };
})();

(function () {
  function get_power_state() {
    if (typeof _get_power_state == 'function') {
      return _get_power_state();
    } else {
      return $.Deferred().reject('not implemented!!!');
    }
  }

  window.get_power_state = get_power_state;
})();

(function () {
  function _tv_configure_show() {
    if (isset('config.tv.allow_register_by_pin')) {
      custom_input({
        title: 'Configuration',
        text: 'Enter room number',
        onConfirm: function (s) {
          custom_input({
            title: 'PIN CODE',
            text: 'Enter confirmation PIN',
            onConfirm: function (p) {
              Loader.start();
              var data = {
                hotelId: get_hotelId(),
                roomNumber: s,
                ip: tv_ip,
                mac: tv_mac,
                manufacturer: tv_manufacturer,
                pin: p,
              };
              $.post(tv_api_url + 'registration_pin', data)
                .done(function (response) {
                  Loader.stop();
                  if (response && response.hasOwnProperty('result')) {
                    switch (response.result) {
                      case 0:
                        storage.setItem('room', s, true);
                        log.persistent.add('room set by pin', 'RELOAD');
                        log.add('TV: reload, room set');
                        reload_app();
                        break;
                      case 1:
                        custom_dialog('alert', 'Error', 'RoomNumber: incorrect PIN', 'tv_configure();');
                        break;
                      default:
                        custom_dialog(
                          'alert',
                          'Error',
                          'RoomNumber: unexpected result ' + response.result,
                          'tv_configure();',
                        );
                        break;
                    }
                  }
                })
                .fail(function (err) {
                  Loader.stop();
                  custom_dialog('alert', 'Error', 'RoomNumber: request failed', 'tv_configure();');
                });
            },
          });
        },
      });
    } else {
      custom_input({
        title: 'Configuration',
        text: 'Enter room number',
        onConfirm: function (s) {
          if (s) {
            storage.setItem('room', s, true);
            log.persistent.add('room set', 'RELOAD');
            log.add('TV: reload, room set');
            reload_app();
          }
        },
      });
    }
  }

  function tv_configure() {
    if (active_page == '#tv_welcome') {
      tv_welcome_hide();
      setTimeout(_tv_configure_show, 1000);
    } else {
      _tv_configure_show();
    }
  }

  window.tv_configure = tv_configure;
})();

(function () {
  function tv_get_info() {
    var out = {
      model: 'Unknown',
      firmware: 'Unknown',
    };
    // TODO sometimes falls here with _tv_get_info is not defined
    if (_tv_get_info && _tv_get_info.firmware && _tv_get_info.model) {
      out = {
        model: _tv_get_info.model(),
        firmware: _tv_get_info.firmware(),
        serial_number: _tv_get_info.serial_number ? _tv_get_info.serial_number() : 'N/A',
      };

      if (_tv_get_info.extra) {
        var tmp = _tv_get_info.extra();
        for (const i in tmp) {
          out[i] = tmp[i];
        }
      }
    }
    return out;
  }

  window.tv_get_info = tv_get_info;
})();

(function () {
  //Hoteza Volume Control
  window.Volume = {
    _hide_timer: null,
    _value: 10,
    init: function () {
      $(document.body).append(
        '<div id="volume_control"><div id="volume_control_line"><div id="volume_control_elapsed"></div><div id="volume_control_bullet"></div></div><div id="volume_control_value">VAL</div><div id="volume_control_icon"></div></div>',
      );
      this._max = $('#volume_control_line').height();
    },
    show: function () {
      if (!$id('volume_control')) {
        this.init();
      }
      $('#volume_control').stop().fadeIn(100);
      this.reset_timer();
    },
    hide: function () {
      this.clear_timer();
      $('#volume_control').fadeOut(100);
    },
    reset_timer: function () {
      this.clear_timer();
      this._hide_timer = setTimeout(function () {
        Volume.hide();
      }, 3000);
    },
    clear_timer: function () {
      if (this._hide_timer) {
        clearTimeout(this._hide_timer);
        this._hide_timer = null;
      }
    },
    set: function (value, background) {
      this._value = parseInt(value).constrain(-1, 99);
      this.set_positions();
      if (!background) {
        this.show();
      }
    },
    set_positions: function () {
      if (!$id('volume_control')) {
        this.init();
      }

      if (this._value == -1) {
        $('#volume_control').addClass('muted');
      } else {
        $('#volume_control_value').html(this._value);
        $('#volume_control').removeClass('muted');
        var tmp = this._value / this._max;
        //easeout
        tmp = 1 - Math.pow(1 - tmp, 3);

        $('#volume_control_bullet').css('bottom', parseInt(tmp * 95) + '%');
        $('#volume_control_elapsed').css('height', parseInt(tmp * 95) + 2 + '%');
      }
    },
  };
})();

(function () {
  window.Keypad = {
    prevPageId: null,
    init: function () {
      $(document.body).append(
        '<div id="hoteza_keypad"><table>' +
          '<tr>' +
          '<td onvclick="custom_input_key(1)">1</td>' +
          '<td onvclick="custom_input_key(2)">2</td>' +
          '<td onvclick="custom_input_key(3)">3</td>' +
          '</tr><tr>' +
          '<td onvclick="custom_input_key(4)">4</td>' +
          '<td onvclick="custom_input_key(5)">5</td>' +
          '<td onvclick="custom_input_key(6)">6</td>' +
          '</tr><tr>' +
          '<td onvclick="custom_input_key(7)">7</td>' +
          '<td onvclick="custom_input_key(8)">8</td>' +
          '<td onvclick="custom_input_key(9)">9</td>' +
          '</tr><tr>' +
          '<td onvclick="custom_input_key(-1)"><svg viewBox="0 -1 28 16"><use xlink:href="#icon-backspace"></use></svg></td>' +
          '<td onvclick="custom_input_key(0)">0</td>' +
          '<td onvclick="Keypad.hide()">OK</td>' +
          '</tr>' +
          '</table></div>',
      );
    },
    _tv_keydown: function (e) {
      var code = e.keyCode;
      switch (code) {
        case tv_keys.LEFT:
          metro_menu_move('left');
          break;
        case tv_keys.RIGHT:
          metro_menu_move('right');
          break;
        case tv_keys.UP:
          metro_menu_move('up');
          break;
        case tv_keys.DOWN:
          metro_menu_move('down');
          break;
        case tv_keys.ENTER:
          tv_cur_elem.trigger(event_link);
          break;
        case tv_keys.BACK:
        case tv_keys.EXIT:
        case tv_keys.NUMBERS:
          Keypad.hide();
          break;

        default:
          break;
      }
    },
    _shown: false,
    show: function () {
      if (tv_cur_block !== 'dialog' && tv_cur_block !== 'settings') {
        return false;
      }

      if (!$id('hoteza_keypad')) {
        this.init();
      }
      $('#hoteza_keypad').stop().fadeIn(100);
      this.prevPageId = tv_cur_block === 'dialog' ? 'dialog' : 'information';
      tv_sel_block('keypad');

      setCurrentTvKeydownOverride(this._tv_keydown);
      this._shown = true;
    },
    hide: function () {
      $('#hoteza_keypad')
        .stop()
        .fadeOut(100, function () {
          $(this).remove();
        });
      tv_sel_block(this.prevPageId);
      removeCurrentTvKeydownOverride();
      this._shown = false;
    },
    toggle: function () {
      if (this._shown) {
        this.hide();
      } else {
        this.show();
      }
    },
  };
})();

(function () {
  window.AutoPoweroff = {
    _timeout_timer: false,
    init: function () {
      var that = this;
      $(document).on('keydown', function () {
        that.start_timeout_timer();
      });
      this.start_timeout_timer();
      log.add('AUTOPOWEROFF: active (' + toHHMMSS() + ')');
    },
    start_timeout_timer: function () {
      var that = this;
      that.stop_timeout_timer();
      that._timeout_timer = setTimeout(
        function () {
          custom_confirm({
            title: 'TV',
            text: getlang('auto_poweroff_timeout_text'),
            cancel: null,
            onConfirm: function () {
              start_timeout_timer();
              log.add('TV: timeout timer reset');
            },
            onCancel: function () {
              //TODO: check value (poweroff, reboot, reload)
              var tmp = isset('config.tv.auto_poweroff.action', 'poweroff');
              log.add('TV: timeout timer ' + tmp);
              switch (tmp) {
                case 'poweroff':
                  log.persistent.add('auto power off', 'POWEROFF');
                  tv_poweroff();
                  break;
                case 'reboot':
                  log.persistent.add('auto power off', 'REBOOT');
                  tv_reboot();
                  break;
                case 'reload':
                  log.persistent.add('auto power off', 'RELOAD');
                  reload_app();
                  break;
                default:
                  log.add('AUTOPOWEROFF: unsupported action ' + tmp);
                  break;
              }
            },
            autoClose: isset('config.tv.auto_poweroff.autoclose_time', 60),
          });
        },
        isset('config.tv.auto_poweroff.poweroff_time', 6) * T_HOUR,
      );
    },
    stop_timeout_timer: function () {
      var that = this;
      if (that._timeout_timer) {
        clearTimeout(that._timeout_timer);
        that._timeout_timer = false;
      }
    },
  };
})();

(function () {
  function openIframe(url) {
    // Создаем iframe элемент
    var iframe = document.createElement('iframe');

    // Устанавливаем атрибут src на нужный URL
    iframe.src = url;

    // Устанавливаем стили для iframe (например, ширина и высота)
    $(iframe).css({
      width: '100%',
      height: '100%',
      border: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1111,
    });

    // Получаем контейнер для iframe
    var container = document.body;

    // Добавляем iframe в контейнер
    container.appendChild(iframe);

    $('#tv_cur').hide();

    return iframe;
  }

  function closeIframe(iframe) {
    $(iframe).remove();
    $('#tv_cur').show();
  }

  function tv_launch_third_party_app(url) {
    var interp = interpolateUrl(url);
    if (!interp.result) {
      console.warn('[tv_launch_third_party_app] cannot open, missing:', interp.reason);
    }
    var url = interp.result || 'about:blank';
    if (typeof _tv_launch_third_party_app !== 'undefined') {
      // особая реализация на LG
      return _tv_launch_third_party_app(url);
    }

    var exitCodes = tv_get_exit_keys(true);
    var iframe = openIframe(url);

    var iframeTimeout = setTimeout(function () {
      console.warn('[tv_launch_third_party_app] iframe load timeout or error');
      tv_close_third_party_app(iframe);
    }, 5000);

    iframe.onerror = function () {
      console.warn('[tv_launch_third_party_app] iframe error');
      clearTimeout(iframeTimeout);
      tv_close_third_party_app(iframe);
    };

    iframe.onload = function () {
      clearTimeout(iframeTimeout);
    };

    tv_keydown_override = function (event) {
      var code = getKeyCode(event);
      if (exitCodes.indexOf(code) > -1) {
        return tv_close_third_party_app(iframe);
      }

      // In order to open Kinopoisk or other applications through this solution,
      // you can use postMessage, but the target application must also handle commands from the parent.
    };
  }

  function tv_close_third_party_app(iframe) {
    closeIframe(iframe);
    tv_keydown_override = null;
  }

  window.tv_launch_third_party_app = tv_launch_third_party_app;
  window.tv_close_third_party_app = tv_close_third_party_app;
})();

(function () {
  /**
   * @typedef {Object} PopupItem
   * @property {string} name - The display name of the item
   * @property {string} onvclick - The action to execute when the item is clicked
   */

  /**
   * @typedef {Object} PopupData
   * @property {string} id - The unique identifier for the popup
   * @property {PopupItem[]} data - Array of items to display in the popup
   * @property {Object} [lang] - Language/localization object
   * @property {string} [lang.title] - The title of the popup
   * @property {string} [lang.itemName] - The name for items (e.g., "minutes")
   * @property {string} [onclose] - Action to execute when popup closes
   * @property {boolean} [tpl] - Whether to use template rendering
   * @property {string} [tplType] - The template type (e.g., 'popup_list')
   * @property {string} [klass] - Additional CSS class for the popup
   * @property {string|null} [to] - Target element selector, should be null
   * NOTE: following properties are legacy, use 'onclose' instead
   * @property {string} [backOnvclick] - Action to execute on back button click
   * @property {string} [backBtn] - Back button page reference
   */
  window.Popup = {
    _popupStack: [],

    /**
     * Displays a popup with the given data and sets the active item
     * @param {PopupData} data - The data object containing popup information
     * @param {number} [activeItemIndex] - The index of the item to be set as active. If not set, first item will be set
     *   every time popup opened. If <= -1 last active item remains without setting particular item.
     * @param {boolean} [rebuild] - If true, the popup will be rebuilt even if it already exists
     * @throws {Error} Throws an error if the ID is missing in the data object
     */
    show: function (data, activeItemIndex, rebuild) {
      if (!data['id']) {
        throw new Error('ID is missing');
      }

      // Use this, to disable href back and then avoid double back navigation
      if (!data['backOnvclick'] && !data['onclose']) {
        data['backOnvclick'] = 'Popup.hide();';
      }

      UI.popup_list_page(data);

      setCurrentTvKeydownOverride(Popup._strict_tv_keydown);

      // Adding class to body to enable customization
      document.body.classList.add('popup_open');

      // Means that remains previous option without setting activeItemIndex
      if ((activeItemIndex !== undefined && activeItemIndex >= 0) || activeItemIndex === undefined) {
        $('#' + data['id'] + ' .tv_sel').removeClass('tv_sel');
        $('#' + data['id'] + ' .tv_cur').removeClass('tv_cur');
      }

      navigate('#' + data['id'], 'popup', true).then(function () {
        // Set active item in list
        if (activeItemIndex !== undefined && activeItemIndex >= 0) {
          for (let i = 0; i < activeItemIndex; i++) {
            tv_down();
          }
        }
      });

      Popup._popupStack.push(data['id']);
    },

    /**
     * Hides the popup with the given ID and restores the previous keydown handler
     */
    hide: function () {
      if (Popup._popupStack.length === 0) {
        log.add('Popup: unnecessary hide call');
        return;
      }

      removeCurrentTvKeydownOverride();

      document.body.classList.remove('popup_open');

      var id = Popup._popupStack.pop();

      navigateBack().then(
        function () {
          $('#' + id).remove();
        },
        function () {
          // case for VOD '#movie_page' which is out of navigation (so navigation fails)
          $('#' + id).remove();
        },
      );
    },
    _strict_tv_keydown: function (e) {
      var code = getKeyCode(e);

      switch (code) {
        case tv_keys.UP:
        case tv_keys.RIGHT:
        case tv_keys.DOWN:
        case tv_keys.LEFT:
        case tv_keys.ENTER:
          tv_keydown(e, true);
          break;
        case tv_keys.BACK:
          if (Popup._checkBackAction()) {
            Popup._execBackAction();
            break;
          }

          Popup.hide();
          break;
        default:
          if (Popup._checkBackAction()) {
            Popup._execBackAction();
            break;
          }

          Popup.hide();
          tv_keydown(e, true);
      }
    },
    // TODO: move to separate functions and use in tv_back()
    _checkBackAction: function () {
      var tmp = $(active_page).find('.back[href_type=back]');
      return tmp.length > 0;
    },
    _execBackAction: function () {
      var tmp = $(active_page).find('.back[href_type=back]');
      if (tmp.length) {
        tmp.trigger(event_link);
      }
    }
  };
})();

(function () {
  /**
   * Set function to override TV keydown handling
   * @param {Function | null} keydown_override - Function to handle keydown events or null to clear override
   * @returns
   */
  function setCurrentTvKeydownOverride(keydown_override) {
    // Example: when we go out from BLE,
    // the event "hcap_application_focus_changed" fired
    // two times with "unfocus" and then "focus" value
    // so "_tv_keydown_apps" is written twice
    if (tv_keydown_override === keydown_override) {
      return false;
    }

    previous_tv_keydown_overrides.push(tv_keydown_override);

    tv_keydown_override = keydown_override;
  }

  function removeCurrentTvKeydownOverride() {
    if (previous_tv_keydown_overrides.length > 0) {
      tv_keydown_override = previous_tv_keydown_overrides.pop();
    } else {
      tv_keydown_override = null;
    }
  }

  window.setCurrentTvKeydownOverride = setCurrentTvKeydownOverride;
  window.removeCurrentTvKeydownOverride = removeCurrentTvKeydownOverride;
})();

(function () {
  // Hide selection indicator (tv_cur)
  function hideSelectionIndicator() {
    $('#tv_cur').hide();
  }

  // Show selection indicator (tv_cur)
  function showSelectionIndicator() {
    $('#tv_cur').show();
  }

  window.hideSelectionIndicator = hideSelectionIndicator;
  window.showSelectionIndicator = showSelectionIndicator;
})();

(function () {
  function _shouldHandleAdditionalKeycodes(code) {
    var additionalKeycodes = isset('config.tv.additionalKeycodes.' + Vendor.get(), []);
    if (additionalKeycodes.length === 0) {
      return false;
    }

    return findInArray(additionalKeycodes, function (k) {
      return k.virtualKeycode === code;
    });
  }

  function _runAdditionalKeycodes(code) {
    var additionalKeycodes = isset('config.tv.additionalKeycodes.' + Vendor.get(), []);
    if (additionalKeycodes.length === 0) {
      return false;
    }

    var keycode = findInArray(additionalKeycodes, function (k) {
      return k.virtualKeycode === code;
    });

    try {
      keycode.fn();
    } catch (err) {
      log.add('_handleAdditionalKeycodes error for code: ' + code + ' ' + JSON.stringify(err));
    }

    return true;
  }

  var _throttledRunAdditionalKeycodes = throttle(_runAdditionalKeycodes, 3000);

  function handleAdditionalKeycodes(code) {
    if (_shouldHandleAdditionalKeycodes(code)) {
      _throttledRunAdditionalKeycodes(code);
      return true;
    }

    return false;
  }

  function handleStandbyKeycodes(code) {
    switch (code) {
      case tv_keys.POWER_ON:
        tv_poweron();
        break;
    }
  }

  window.handleAdditionalKeycodes = handleAdditionalKeycodes;
  window.handleStandbyKeycodes = handleStandbyKeycodes;
})();

(function () {
  function setStandbyTvKeydownHandler() {
    if (typeof _setStandbyTvKeydownHandler === 'undefined') {
      return false;
    }

    return _setStandbyTvKeydownHandler();
  }

  window.setStandbyTvKeydownHandler = setStandbyTvKeydownHandler;
})();

(function () {
  /* Used in Hotel ID 517 (PLN), 1326 (PLN Lab) for handling power-on with additional keycodes */
  /**
   * @param {object} payload
   * @param {string?} payload.reason = keydown
   * @param {(enumerable | number)?} payload.value = tv_keys || tv_keys.values
   * */
  function setStartupReason(payload) {
    storage.setItem('startupReason', JSON.stringify(payload));
  }

  function checkStartupReason() {
    var startupReason = null;
    try {
      startupReason = JSON.parse(storage.getItem('startupReason'));
    } catch (err) {}

    if (!startupReason || Object.keys(startupReason).length === 0) {
      return false;
    }

    switch (startupReason.reason) {
      case 'keydown':
        Vendor.sendKey(startupReason.value);
        break;
    }

    setStartupReason({});
  }

  /**
   * If TV is in standby, powers on and defers the action to be executed after startup.
   * @param {object} payload
   * @param {string} [payload.reason]
   * @param {string | number} [payload.value]
   * @returns {boolean} true if TV was in standby and power-on was triggered
   */
  function wakeUpAndDeferAction(payload) {
    if (tv_virtual_standby_state == true) {
      setStartupReason(payload);
      tv_poweron();
      return true;
    }
    return false;
  }

  window.setStartupReason = setStartupReason;
  window.checkStartupReason = checkStartupReason;
  window.wakeUpAndDeferAction = wakeUpAndDeferAction;
})();

(function () {
  function setBrightness(val) {
    if (window._setBrightness && typeof window._setBrightness === 'function') {
      window._setBrightness(val);
    }
  }

  window.setBrightness = setBrightness;
})();

(function () {
  /**
   * Gets the TV name based on the hotel configuration and room number.
   * Two forms are possible:
   * 1) If hotel name is set in config, it returns "{hotelName} {roomNumber} {getTVIDName()} TV" (needed for Google Cast built-in certification standards)
   * 2) If hotel name is not set, it returns "Room {roomNumber}"
   * @returns {string}
   */
  function getTvName() {
    // TODO: make a separate functionality for setting a name template
    // and processing of this template using a separate function + rxjs for the reaction to change
    // of this template inside the application itself
    var tvidName = Events.getTVIDName();
    if (tvidName === 'not set') {
      tvidName = '';
    }
    return isset('config.hotelName', 'Room') + ' ' + tv_room + ' ' + tvidName + (!tvidName ? '' : ' ') + 'TV';
  }

  window.getTvName = getTvName;
})();
